const data = {
  title: 'Shifting Focus',
  model: 'Rolex',
  description: "Patek Philippe Watches chronograph steel / gold automatic men's watch 116503 ",
  price: 230140,
  tagTypes: ['check_outline', 'hot_outline'],
  imgUrl: '/img/card_img.png',
};

export const mock = [data, data, data, data, data];

// export const brands = [
//   {
//     title: 'Audemars Piguet',
//     logo: '/img/audemars piguet-black.png',
//     entityId: '9247d094-9de7-401a-0f62-08da4aa68096',
//   },
//   {
//     title: 'Breguet',
//     logo: brandsLogoByShop_2,
//     entityId: '591a398d-764c-445e-2bc0-08da5d9850d6',
//   },
//   {
//     title: 'Patek Philippe',
//     logo: '/img/patek-philippe-black.png',
//     entityId: '19c5dc9d-ef62-4c11-0f69-08da4aa68096',
//   },
//   {
//     title: 'Vacheron Constantin',
//     logo: '/img/constantin-black.png',
//     entityId: 'bafe575c-8902-46b8-0f6a-08da4aa68096',
//   },
//   {
//     title: 'Rolex',
//     logo: '/img/rolex-black.png',
//     entityId: '7088289d-eecc-4ab6-0f68-08da4aa68096',
//   },
//   {
//     title: 'F.P.Journe',
//     logo: brandsLogoByShop_0,
//     entityId: '7bb309d9-7969-4834-baea-08da5c131933',
//   },
//   {
//     title: 'IWC',
//     logo: brandsLogoByShop_1,
//     entityId: 'b5748ff1-70e7-43ff-2bcc-08da5d9850d6',
//   },
//   {
//     title: 'Breitling',
//     logo: '/img/breitling-black.png',
//     entityId: '3837afda-e5d7-4da9-0f73-08da4aa68096',
//   },
//   {
//     title: 'Hublot',
//     logo: '/img/hublot-black.png',
//     entityId: 'c5cfe2c6-35b5-40e2-0f6d-08da4aa68096',
//   },
//   {
//     title: 'Ulysse Nardin',
//     logo: '/img/ulysse-nardin-black.png',
//     entityId: 'e42e66a4-5b80-483e-0f6e-08da4aa68096',
//   },
// ];

export const brandDescriptionMock = [
  '<p>Variety of target audiences (from watch fans dreaming of their Grail watches for years to professional investors and collectors of unique pieces)</p> ',
  '<p>Variety of models (there are the models for everyone. From discontinued or vintage rare watches to the incredibly demanded new models)</p> ',
  '<p>Flexible prices (market demand drives pricing and these tendencies are extremely flexible. Our team of watch experts follows the market trends daily to provide our clients with the best price options and recommendations on how to invest smartly)</p> ',
  `<p>Multi Brand luxury watches boutique <b>Chrono 10:10 was opened in October 2018 in Intercontinental boutique on Pařížská street in Prague.</b> On this street, most of the fashion and luxury watches or jewelry stores and boutiques are located (Audemars Piguet, Rolex, Patek Philippe, Louis Vuitton, Chanel, Cartier, etc). Our team of professionals quickly established a reputation as trustworthy advisers and partners among local and international watch enthusiasts.
  <br/>
  <br/>
  <b>Chrono 10:10</b> always tries to fulfill your wishes to the maximum with our professionalism and sincerity. Presenting luxury brands (like Rolex, Patek Philippe, Audemars Piguet, F.P. Journe, A. Lange & Söhne, Vacheron Constantin, IWC, Jaeger-LeCoultre, Franck Muller and others), with over 1,000 models in our galleries, <b>Chrono 10:10 strive to give people a sense of happiness</b>, because we believe that everyone is special, and that small pleasures are hidden in carefully selected details. A special place in our offer is our repair service, which has "revived" your dear memories countless times so far.</p>`,
  `<p>Why is the secondary market for the luxury Swiss the best option? Here is just so</p>`,
];

const HeroMocks = [
  {
    title: 'New Arrivals',
    subtitle: 'Stay up to date with our new products and do not miss out on our unique offers',
    subtitleMobile: 'Stay up to date with our new products',
    imgUrl: '/img/home-page-banner.png',
    buttons: ['Shop collection'],
  },
  {
    title: 'High quality service for your watch',
    subtitle: `We provide quality service in our in-house service center for watches of any complexity beside selling high class Swiss watches`,
    imgUrl: '/img/service-page.png',
    buttons: ['Contact us', 'Prices'],
  },
  {
    title: 'Repair your watch now!',
    subtitle: `We provide 1 year warranty for all mechanical parts of the watch.`,
    imgUrl: '/img/service-footer.png',
    buttons: ['Contact us'],
  },
  {
    title: 'We provide service for your watch',
    subtitle:
      'We provide quality service in our in-house service center for watches of any complexity beside selling high class Swiss watches',
    imgUrl: '/img/go-to-service.png',
    buttons: ['Book Service'],
  },
  {
    title: 'All watches',
    subtitle: `Explore the wide selection of high end pre-owned Swiss watches and choose your dream timepiece`,
    imgUrl: '/img/all-watches-main.png',
    buttons: ['Contact us', 'Prices'],
  },
  {
    title: 'Brands',
    subtitle: `Select from a wide range of luxury Swiss watch brands and start your way to your dream watch`,
    imgUrl: '/img/IMG_2722-2 1.png',
    buttons: ['Contact us'],
  },
  {
    title: 'About us',
    subtitle:
      'We are the market leaders in the sale of watches, as well as we have a very high-quality repair service for watches ',
    imgUrl: '/img/about-main.png',
    buttons: ['Read More'],
  },
  {
    title: 'Consignment sale',
    subtitle:
      'We are glad to provide a consignment selling of your watch. It is a carefree procedure in which you are able to delegate the entire process of selling your watch to our specialists. We will completely organize the overall sales process, from service maintenance of your watch to communication with the potential customers.',
    imgUrl: '/img/commission.png',
    buttons: [],
  },
];
export const HeroSlidersMock = [
  { ...HeroMocks[0], id: 1 },
  { ...HeroMocks[1], id: 2 },
  { ...HeroMocks[2], id: 3 },
  { ...HeroMocks[3], id: 4 },
  { ...HeroMocks[4], id: 5 },
  { ...HeroMocks[5], id: 6 },
  { ...HeroMocks[6], id: 7 },
  { ...HeroMocks[7], id: 8 },
];

export const collectionMocks = [
  {
    id: 1,
    url: 'https://www.orientalwatch.com/images/rolex/landing_page/desktop/mens-watches_gmt_master_2.jpg',
    subtitle: "Time's Picks",
  },
  {
    id: 2,
    url: 'https://rossbender.org/wp-content/uploads/2022/01/Rolex-watches.jpeg',
    subtitle: "Time's Picks",
  },
  {
    id: 3,
    url: 'https://www.firstclasswatches.co.uk/blog/wp-content/uploads/2021/07/clock-2752610_1920-1.jpg',
    subtitle: "Time's Picks",
  },
];

export const instaData = {
  title: 'Inspiration in real life',
  subTitle: 'Want to be the first to know?',
};

export const watches = [
  {
    createdAt: '2022-08-10T22:14:58.82872',
    modifiedAt: '2022-10-24T22:21:20.9711671',
    tags: [],
    images: [
      {
        url: 'https://ucarecdn.com/ae148c8e-774c-4e76-9803-ccfb187acbd6/-/preview/1000x1000/-/format/webp/Audemars Piguet-Audemars Piguet Royal Oak Offshore Diver Box+Extract from the archives 2012-15703ST.OO.A002CA.01',
        fileName: null,
        path: null,
        containerName: null,
      },
      {
        url: 'https://ucarecdn.com/a54fa83d-c60b-4eb7-ac73-60dd6e870a93/-/preview/1000x1000/-/format/webp/Audemars Piguet-Audemars Piguet Royal Oak Offshore Diver Box+Extract from the archives 2012-15703ST.OO.A002CA.01',
        fileName: null,
        path: null,
        containerName: null,
      },
      {
        url: 'https://ucarecdn.com/23ccec53-5104-45a2-b83d-ac47c1ca21ac/-/preview/1000x1000/-/format/webp/Audemars Piguet-Audemars Piguet Royal Oak Offshore Diver Box+Extract from the archives 2012-15703ST.OO.A002CA.01',
        fileName: null,
        path: null,
        containerName: null,
      },
      {
        url: 'https://ucarecdn.com/989f55ac-c84b-43fc-9669-a9ee0fa167f2/-/preview/1000x1000/-/format/webp/Audemars Piguet-Audemars Piguet Royal Oak Offshore Diver Box+Extract from the archives 2012-15703ST.OO.A002CA.01',
        fileName: null,
        path: null,
        containerName: null,
      },
      {
        url: 'https://ucarecdn.com/bb317c60-ac23-47e1-8826-7f04228ec1a7/-/preview/1000x1000/-/format/webp/Audemars Piguet-Audemars Piguet Royal Oak Offshore Diver Box+Extract from the archives 2012-15703ST.OO.A002CA.01',
        fileName: null,
        path: null,
        containerName: null,
      },
      {
        url: 'https://ucarecdn.com/e5158803-32f8-4c38-a1cb-59b0f8b3508e/-/preview/1000x1000/-/format/webp/Audemars Piguet-Audemars Piguet Royal Oak Offshore Diver Box+Extract from the archives 2012-15703ST.OO.A002CA.01',
        fileName: null,
        path: null,
        containerName: null,
      },
      {
        url: 'https://ucarecdn.com/644ace92-a195-48bf-b208-964f5b09e9a9/-/preview/1000x1000/-/format/webp/Audemars Piguet-Audemars Piguet Royal Oak Offshore Diver Box+Extract from the archives 2012-15703ST.OO.A002CA.01',
        fileName: null,
        path: null,
        containerName: null,
      },
      {
        url: 'https://ucarecdn.com/67b56fec-609d-4c28-b144-d0f72cf6fd9b/-/preview/1000x1000/-/format/webp/Audemars Piguet-Audemars Piguet Royal Oak Offshore Diver Box+Extract from the archives 2012-15703ST.OO.A002CA.01',
        fileName: null,
        path: null,
        containerName: null,
      },
    ],
    documents: [],
    model: {
      createdAt: '2022-07-04T08:36:51.2444307',
      modifiedAt: '2022-07-04T08:36:51.2444307',
      brand: {
        createdAt: '2022-07-04T08:36:39.9541209',
        modifiedAt: '2022-07-04T08:36:39.9541209',
        fileLogoImage: null,
        fileImage: null,
        id: '1e1f001c-5def-4617-2bbd-08da5d9850d6',
        name: 'Audemars Piguet',
        title: '',
        description: '',
        stringImage: null,
        stringLogoImage: null,
      },
      fileImage: null,
      id: 'b7b29f72-59e3-4ac8-a9c5-08da5d9850d7',
      brandId: '9247d094-9de7-401a-0f62-08da4aa68096',
      name: 'Royal Oak Offshore Diver',
      stringImage: null,
    },
    id: '50897e98-e5b5-4b45-bf03-08da7b1d893d',
    modelId: 'b7b29f72-59e3-4ac8-a9c5-08da5d9850d7',
    price: 27300,
    availability: 'InStock',
    caseDiameter: '42 mm',
    refNumber: '15703ST.OO.A002CA.01',
    movement: 'Automatic',
    braceletMaterial: 'Rubber',
    braceletColor: 'Black',
    clasp: 'Buckle',
    claspMaterial: 'Steel',
    description: '',
    dealerProductCode: '@1010N3724',
    caseMaterial: 'Steel',
    yearProduction: '2012',
    condition: 'Very good\n                     (Worn with little to no signs of wear)',
    scopeDelivery: 'Original box, original papers',
    dial: 'Black',
    dialNumerals: 'No numerals',
    name: 'Audemars Piguet Royal Oak Offshore Diver Box+Extract from the archives 2012',
    bezelMaterial: 'Steel',
    crystal: 'Sapphire crystal',
    published: true,
    url: 'https://www.chrono24.com/audemarspiguet/audemars-piguet-royal-oak-offshore-diver-boxextract-from-the-archives-2012--id23369802.htm',
    gender: '',
  },
  {
    createdAt: '2022-09-27T22:30:15.5849816',
    modifiedAt: '2022-11-01T13:23:53.2132658',
    tags: [],
    images: [
      {
        url: 'https://ucarecdn.com/7444c680-31d3-47ba-a281-872b9163bca5/-/preview/1000x1000/-/format/webp/Audemars Piguet-Audemars Piguet Royal Oak RG with extract from the archives-14800OR.OO.0009XX.01',
        fileName: null,
        path: null,
        containerName: null,
      },
      {
        url: 'https://ucarecdn.com/bbd17532-0000-4dd5-a528-f17c5b03e3c1/-/preview/1000x1000/-/format/webp/Audemars Piguet-Audemars Piguet Royal Oak RG with extract from the archives-14800OR.OO.0009XX.01',
        fileName: null,
        path: null,
        containerName: null,
      },
      {
        url: 'https://ucarecdn.com/f52871e2-3dea-4186-a63d-c5e762a1ea0a/-/preview/1000x1000/-/format/webp/Audemars Piguet-Audemars Piguet Royal Oak RG with extract from the archives-14800OR.OO.0009XX.01',
        fileName: null,
        path: null,
        containerName: null,
      },
      {
        url: 'https://ucarecdn.com/ad85ee9c-f1d7-4ebb-87e8-0ea322473f04/-/preview/1000x1000/-/format/webp/Audemars Piguet-Audemars Piguet Royal Oak RG with extract from the archives-14800OR.OO.0009XX.01',
        fileName: null,
        path: null,
        containerName: null,
      },
      {
        url: 'https://ucarecdn.com/80c9cca0-eed1-43c1-9664-f042e7ced82b/-/preview/1000x1000/-/format/webp/Audemars Piguet-Audemars Piguet Royal Oak RG with extract from the archives-14800OR.OO.0009XX.01',
        fileName: null,
        path: null,
        containerName: null,
      },
    ],
    documents: [],
    model: {
      createdAt: '2022-06-10T06:00:21.8161982',
      modifiedAt: '2022-06-10T06:00:21.8161982',
      brand: {
        createdAt: '2022-06-10T06:00:21.8074198',
        modifiedAt: '2022-06-10T06:00:21.8074198',
        fileLogoImage: null,
        fileImage: null,
        id: '9247d094-9de7-401a-0f62-08da4aa68096',
        name: 'Audemars Piguet',
        title: '',
        description: '',
        stringImage: null,
        stringLogoImage: null,
      },
      fileImage: null,
      id: 'af96c847-07e6-400c-6795-08da4aa6809a',
      brandId: '9247d094-9de7-401a-0f62-08da4aa68096',
      name: 'Royal Oak',
      stringImage: null,
    },
    id: '025dd450-27d5-492d-e6e2-08da9b57b2bd',
    modelId: 'af96c847-07e6-400c-6795-08da4aa6809a',
    price: 28500,
    availability: 'InStock',
    caseDiameter: '36 mm',
    refNumber: '14800OR.OO.0009XX.01',
    movement: 'Automatic',
    braceletMaterial: 'Leather',
    braceletColor: '',
    clasp: '',
    claspMaterial: '',
    description: '',
    dealerProductCode: '1010K4283',
    caseMaterial: 'Rose gold',
    yearProduction: '1998',
    condition: 'Very good\n                     (Worn with little to no signs of wear)',
    scopeDelivery: 'Original papers, no original box',
    dial: 'Gold (solid)',
    dialNumerals: '',
    name: 'Audemars Piguet Royal Oak RG with extract from the archives',
    bezelMaterial: '',
    crystal: '',
    published: true,
    url: 'https://www.chrono24.com/audemarspiguet/audemars-piguet-royal-oak-rg-with-extract-from-the-archives--id25552037.htm',
  },
  {
    createdAt: '2022-06-10T06:00:21.8154703',
    modifiedAt: '2022-11-01T13:23:57.1467204',
    tags: [],
    images: [
      {
        url: 'https://ucarecdn.com/f364bc8a-8ac8-42e8-ac3d-b562ab93a55b/-/preview/1000x1000/-/format/webp/Audemars Piguet-Audemars Piguet Royal Oak Offshore-25721ST.jpeg',
        fileName: null,
        path: null,
        containerName: null,
      },
      {
        url: 'https://ucarecdn.com/a629562d-0255-4e3d-93be-46f64c36346c/-/preview/1000x1000/-/format/webp/Audemars Piguet-Audemars Piguet Royal Oak Offshore-25721ST.jpeg',
        fileName: null,
        path: null,
        containerName: null,
      },
      {
        url: 'https://ucarecdn.com/2e5234aa-60d8-48e8-807a-c15688e306b7/-/preview/1000x1000/-/format/webp/Audemars Piguet-Audemars Piguet Royal Oak Offshore-25721ST.jpeg',
        fileName: null,
        path: null,
        containerName: null,
      },
      {
        url: 'https://ucarecdn.com/016d24fa-8a0a-4ee6-aa63-1a2718afd8ba/-/preview/1000x1000/-/format/webp/Audemars Piguet-Audemars Piguet Royal Oak Offshore-25721ST.jpeg',
        fileName: null,
        path: null,
        containerName: null,
      },
      {
        url: 'https://ucarecdn.com/47493f5c-3015-4bd0-ad92-42a4bc83da8d/-/preview/1000x1000/-/format/webp/Audemars Piguet-Audemars Piguet Royal Oak Offshore-25721ST.jpeg',
        fileName: null,
        path: null,
        containerName: null,
      },
      {
        url: 'https://ucarecdn.com/7a8c62a3-265b-4d53-b3d3-0f33b7131f3a/-/preview/1000x1000/-/format/webp/Audemars Piguet-Audemars Piguet Royal Oak Offshore-25721ST.jpeg',
        fileName: null,
        path: null,
        containerName: null,
      },
      {
        url: 'https://ucarecdn.com/0201f210-865a-4e3a-a47c-bd58e701cdb9/-/preview/1000x1000/-/format/webp/Audemars Piguet-Audemars Piguet Royal Oak Offshore-25721ST.jpeg',
        fileName: null,
        path: null,
        containerName: null,
      },
      {
        url: 'https://ucarecdn.com/f8f9ceaf-d135-46cc-9034-b55e5ce310b7/-/preview/1000x1000/-/format/webp/Audemars Piguet-Audemars Piguet Royal Oak Offshore-25721ST.jpeg',
        fileName: null,
        path: null,
        containerName: null,
      },
      {
        url: 'https://ucarecdn.com/923ae8ab-4a27-49a8-8e2a-19d65fceaf72/-/preview/1000x1000/-/format/webp/Audemars Piguet-Audemars Piguet Royal Oak Offshore-25721ST.jpeg',
        fileName: null,
        path: null,
        containerName: null,
      },
      {
        url: 'https://ucarecdn.com/5a63c16b-c5d4-42da-9545-98cf36228f4f/-/preview/1000x1000/-/format/webp/Audemars Piguet-Audemars Piguet Royal Oak Offshore-25721ST.jpeg',
        fileName: null,
        path: null,
        containerName: null,
      },
      {
        url: 'https://ucarecdn.com/7a716932-fa0e-46d1-9618-2ab4fd5b1a0b/-/preview/1000x1000/-/format/webp/Audemars Piguet-Audemars Piguet Royal Oak Offshore-25721ST.jpeg',
        fileName: null,
        path: null,
        containerName: null,
      },
    ],
    documents: [],
    model: {
      createdAt: '2022-06-10T06:00:21.8077371',
      modifiedAt: '2022-06-10T06:00:21.8077371',
      brand: {
        createdAt: '2022-06-10T06:00:21.8074198',
        modifiedAt: '2022-06-10T06:00:21.8074198',
        fileLogoImage: null,
        fileImage: null,
        id: '9247d094-9de7-401a-0f62-08da4aa68096',
        name: 'Audemars Piguet',
        title: '',
        description: '',
        stringImage: null,
        stringLogoImage: null,
      },
      fileImage: null,
      id: 'fe5c4ad7-d71a-4f91-664b-08da4aa6809a',
      brandId: '9247d094-9de7-401a-0f62-08da4aa68096',
      name: 'Royal Oak Offshore Chronograph',
      stringImage: null,
    },
    id: '25ee0d87-b5fc-46d4-a0c5-08da4aa6809c',
    modelId: 'fe5c4ad7-d71a-4f91-664b-08da4aa6809a',
    price: 35500,
    availability: 'InStock',
    caseDiameter: '',
    refNumber: '25721ST',
    movement: 'Automatic',
    braceletMaterial: 'Steel',
    braceletColor: 'Steel',
    clasp: 'Fold clasp',
    claspMaterial: 'Steel',
    description: '',
    dealerProductCode: '1010N3760',
    caseMaterial: 'Steel',
    yearProduction: '',
    condition: 'Very good\n                     (Worn with little to no signs of wear)',
    scopeDelivery: 'Original box, no original papers',
    dial: 'Blue',
    dialNumerals: 'Arabic numerals',
    name: 'Audemars Piguet Royal Oak Offshore Chronograph Official Dial Replacement by Bucherer AG',
    bezelMaterial: 'Steel',
    crystal: 'Sapphire crystal',
    published: true,
    url: 'https://www.chrono24.com/audemarspiguet/audemars-piguet-royal-oak-offshore-official-dial-replacement-by-bucherer-ag--id23694811.htm',
  },
  {
    createdAt: '2022-09-05T22:30:28.9198555',
    modifiedAt: '2022-11-01T13:23:29.0861589',
    tags: [],
    images: [
      {
        url: 'https://ucarecdn.com/487a24f5-3eca-4b10-92fa-27f8ae6154b8/-/preview/1000x1000/-/format/webp/Audemars Piguet-Audemars Piguet Royal Oak Offshore Chronograph 25940OK.OO.D002CA.02-25940OK.OO.D002CA.02',
        fileName: null,
        path: null,
        containerName: null,
      },
      {
        url: 'https://ucarecdn.com/f79267e2-cf06-4087-800f-afd259d2df89/-/preview/1000x1000/-/format/webp/Audemars Piguet-Audemars Piguet Royal Oak Offshore Chronograph 25940OK.OO.D002CA.02-25940OK.OO.D002CA.02',
        fileName: null,
        path: null,
        containerName: null,
      },
      {
        url: 'https://ucarecdn.com/d876b58b-798b-4b28-ab1b-0491862dfd45/-/preview/1000x1000/-/format/webp/Audemars Piguet-Audemars Piguet Royal Oak Offshore Chronograph 25940OK.OO.D002CA.02-25940OK.OO.D002CA.02',
        fileName: null,
        path: null,
        containerName: null,
      },
      {
        url: 'https://ucarecdn.com/c55cfe8f-6c99-47d0-8f6c-2dac23a32482/-/preview/1000x1000/-/format/webp/Audemars Piguet-Audemars Piguet Royal Oak Offshore Chronograph 25940OK.OO.D002CA.02-25940OK.OO.D002CA.02',
        fileName: null,
        path: null,
        containerName: null,
      },
      {
        url: 'https://ucarecdn.com/af38266e-81fc-44e4-b7da-f1832e9cbf65/-/preview/1000x1000/-/format/webp/Audemars Piguet-Audemars Piguet Royal Oak Offshore Chronograph 25940OK.OO.D002CA.02-25940OK.OO.D002CA.02',
        fileName: null,
        path: null,
        containerName: null,
      },
      {
        url: 'https://ucarecdn.com/2685a508-46b5-4842-a835-3ef0b1b5457e/-/preview/1000x1000/-/format/webp/Audemars Piguet-Audemars Piguet Royal Oak Offshore Chronograph 25940OK.OO.D002CA.02-25940OK.OO.D002CA.02',
        fileName: null,
        path: null,
        containerName: null,
      },
      {
        url: 'https://ucarecdn.com/0d46eeda-0f72-49c3-8c2e-9479c32369db/-/preview/1000x1000/-/format/webp/Audemars Piguet-Audemars Piguet Royal Oak Offshore Chronograph 25940OK.OO.D002CA.02-25940OK.OO.D002CA.02',
        fileName: null,
        path: null,
        containerName: null,
      },
    ],
    documents: [],
    model: {
      createdAt: '2022-06-10T06:00:21.8077371',
      modifiedAt: '2022-06-10T06:00:21.8077371',
      brand: {
        createdAt: '2022-06-10T06:00:21.8074198',
        modifiedAt: '2022-06-10T06:00:21.8074198',
        fileLogoImage: null,
        fileImage: null,
        id: '9247d094-9de7-401a-0f62-08da4aa68096',
        name: 'Audemars Piguet',
        title: '',
        description: '',
        stringImage: null,
        stringLogoImage: null,
      },
      fileImage: null,
      id: 'fe5c4ad7-d71a-4f91-664b-08da4aa6809a',
      brandId: '9247d094-9de7-401a-0f62-08da4aa68096',
      name: 'Royal Oak Offshore Chronograph',
      stringImage: null,
    },
    id: 'e58d76e6-cf9d-4c31-7411-08da8ad73c9b',
    modelId: 'fe5c4ad7-d71a-4f91-664b-08da4aa6809a',
    price: 34500,
    availability: 'InStock',
    caseDiameter: '42 mm',
    refNumber: '25940OK.OO.D002CA.02',
    movement: 'Automatic',
    braceletMaterial: 'Rubber',
    braceletColor: 'Black',
    clasp: 'Fold clasp',
    claspMaterial: 'Rose Gold',
    description: '',
    dealerProductCode: '1010N4219',
    caseMaterial: 'Rose gold',
    yearProduction: '',
    condition: 'Very good\n                     (Worn with little to no signs of wear)',
    scopeDelivery: 'Original box, original papers',
    dial: 'Black',
    dialNumerals: 'Arabic numerals',
    name: 'Audemars Piguet Royal Oak Offshore Chronograph 25940OK.OO.D002CA.02',
    bezelMaterial: 'Rose gold',
    crystal: 'Sapphire crystal',
    published: true,
    url: 'https://www.chrono24.com/audemarspiguet/audemars-piguet-royal-oak-offshore-chronograph--id25281814.htm',
  },

  {
    createdAt: '2022-06-10T06:00:21.8090413',
    modifiedAt: '2022-11-01T13:24:46.3791077',
    tags: [],
    images: [
      {
        url: 'https://ucarecdn.com/b5405b4a-2aab-4019-b2fd-e70b58a92a5f/-/preview/1000x1000/-/format/webp/Breguet-Breguet Héritage-3660br-12-984.jpeg',
        fileName: null,
        path: null,
        containerName: null,
      },
      {
        url: 'https://ucarecdn.com/4ac2851f-a403-401e-85c0-cf2881e4e4f2/-/preview/1000x1000/-/format/webp/Breguet-Breguet Héritage-3660br-12-984.jpeg',
        fileName: null,
        path: null,
        containerName: null,
      },
      {
        url: 'https://ucarecdn.com/9d05bf76-58f6-4f08-987a-f8560056c635/-/preview/1000x1000/-/format/webp/Breguet-Breguet Héritage-3660br-12-984.jpeg',
        fileName: null,
        path: null,
        containerName: null,
      },
      {
        url: 'https://ucarecdn.com/5bd60f70-a424-4d47-967a-d42ec92158e6/-/preview/1000x1000/-/format/webp/Breguet-Breguet Héritage-3660br-12-984.jpeg',
        fileName: null,
        path: null,
        containerName: null,
      },
      {
        url: 'https://ucarecdn.com/13e5cd44-bd8c-4cd5-9d4d-dfbdb494f9b3/-/preview/1000x1000/-/format/webp/Breguet-Breguet Héritage-3660br-12-984.jpeg',
        fileName: null,
        path: null,
        containerName: null,
      },
      {
        url: 'https://ucarecdn.com/2951e1cd-a75d-458a-ac59-6dc500773db2/-/preview/1000x1000/-/format/webp/Breguet-Breguet Héritage-3660br-12-984.jpeg',
        fileName: null,
        path: null,
        containerName: null,
      },
      {
        url: 'https://ucarecdn.com/da33b733-2167-4207-a6c8-ff5b8dd1b996/-/preview/1000x1000/-/format/webp/Breguet-Breguet Héritage-3660br-12-984.jpeg',
        fileName: null,
        path: null,
        containerName: null,
      },
    ],
    documents: [],
    model: {
      createdAt: '2022-06-10T06:00:21.8079533',
      modifiedAt: '2022-06-10T06:00:21.8079533',
      brand: {
        createdAt: '2022-06-10T06:00:21.8075021',
        modifiedAt: '2022-06-10T06:00:21.8075021',
        fileLogoImage: null,
        fileImage: null,
        id: '5992ed37-b9a2-4074-0f67-08da4aa68096',
        name: 'Breguet',
        title: '',
        description: '',
        stringImage: null,
        stringLogoImage: null,
      },
      fileImage: null,
      id: 'f1f6c828-4af7-4163-6660-08da4aa6809a',
      brandId: '591a398d-764c-445e-2bc0-08da5d9850d6',
      name: 'Héritage',
      stringImage: null,
    },
    id: '64bde7fb-d30f-4446-9eff-08da4aa6809c',
    modelId: 'f1f6c828-4af7-4163-6660-08da4aa6809a',
    price: 13500,
    availability: 'InStock',
    caseDiameter: '35 x 29.6 mm',
    refNumber: '3660br/12/984',
    movement: 'Automatic',
    braceletMaterial: '',
    braceletColor: 'Brown',
    clasp: 'Buckle',
    claspMaterial: '',
    description: '',
    dealerProductCode: '1010N3744',
    caseMaterial: 'Rose gold',
    yearProduction: '',
    condition: 'Very good\n                     (Worn with little to no signs of wear)',
    scopeDelivery: 'Original box, original papers',
    dial: 'Silver',
    dialNumerals: 'Roman numerals',
    name: 'Breguet Héritage 3660br/12/984',
    bezelMaterial: '',
    crystal: 'Sapphire crystal',
    published: true,
    url: 'https://www.chrono24.com/breguet/breguet-heritage--id17878476.htm',
  },
  {
    createdAt: '2022-06-10T06:00:21.8075364',
    modifiedAt: '2022-11-01T13:24:25.597205',
    tags: [],
    images: [
      {
        url: 'https://ucarecdn.com/e3c65505-c0a6-4f03-a6df-fcc56c9c59e4/-/preview/1000x1000/-/format/webp/Breguet-Breguet Marine Big Date Black Dial Box+Papers 2008-5817ST-92-5V8.jpeg',
        fileName: null,
        path: null,
        containerName: null,
      },
      {
        url: 'https://ucarecdn.com/c4ebc8e2-f815-47ed-ad83-32c02001f35d/-/preview/1000x1000/-/format/webp/Breguet-Breguet Marine Big Date Black Dial Box+Papers 2008-5817ST-92-5V8.jpeg',
        fileName: null,
        path: null,
        containerName: null,
      },
      {
        url: 'https://ucarecdn.com/00f9c99c-14a3-45c0-897e-a5fb05306869/-/preview/1000x1000/-/format/webp/Breguet-Breguet Marine Big Date Black Dial Box+Papers 2008-5817ST-92-5V8.jpeg',
        fileName: null,
        path: null,
        containerName: null,
      },
      {
        url: 'https://ucarecdn.com/a67e1a14-979e-4554-8594-bc0e13459c64/-/preview/1000x1000/-/format/webp/Breguet-Breguet Marine Big Date Black Dial Box+Papers 2008-5817ST-92-5V8.jpeg',
        fileName: null,
        path: null,
        containerName: null,
      },
      {
        url: 'https://ucarecdn.com/62f4fe37-46c1-464a-a72d-9b9a5543e95a/-/preview/1000x1000/-/format/webp/Breguet-Breguet Marine Big Date Black Dial Box+Papers 2008-5817ST-92-5V8.jpeg',
        fileName: null,
        path: null,
        containerName: null,
      },
      {
        url: 'https://ucarecdn.com/a7660d17-5280-4248-a6fa-acce2da56d8c/-/preview/1000x1000/-/format/webp/Breguet-Breguet Marine Big Date Black Dial Box+Papers 2008-5817ST-92-5V8.jpeg',
        fileName: null,
        path: null,
        containerName: null,
      },
      {
        url: 'https://ucarecdn.com/82abf2dc-6fb6-4529-bc03-158e2259ff69/-/preview/1000x1000/-/format/webp/Breguet-Breguet Marine Big Date Black Dial Box+Papers 2008-5817ST-92-5V8.jpeg',
        fileName: null,
        path: null,
        containerName: null,
      },
    ],
    documents: [],
    model: {
      createdAt: '2022-06-10T06:00:21.8075326',
      modifiedAt: '2022-06-10T06:00:21.8075326',
      brand: {
        createdAt: '2022-06-10T06:00:21.8075021',
        modifiedAt: '2022-06-10T06:00:21.8075021',
        fileLogoImage: null,
        fileImage: null,
        id: '5992ed37-b9a2-4074-0f67-08da4aa68096',
        name: 'Breguet',
        title: '',
        description: '',
        stringImage: null,
        stringLogoImage: null,
      },
      fileImage: null,
      id: 'ba3a127a-5722-4078-6634-08da4aa6809a',
      brandId: '591a398d-764c-445e-2bc0-08da5d9850d6',
      name: 'Marine',
      stringImage: null,
    },
    id: '542c377a-6478-471e-9e2c-08da4aa6809c',
    modelId: 'ba3a127a-5722-4078-6634-08da4aa6809a',
    price: 14100,
    availability: 'InStock',
    caseDiameter: '39 mm',
    refNumber: '5817ST/92/5V8',
    movement: 'Automatic',
    braceletMaterial: 'Rubber',
    braceletColor: 'Black',
    clasp: 'Fold clasp',
    claspMaterial: 'Steel',
    description: '',
    dealerProductCode: '1010N3764',
    caseMaterial: 'Steel',
    yearProduction: '2008',
    condition: 'Very good\n                     (Worn with little to no signs of wear)',
    scopeDelivery: 'Original box, original papers',
    dial: 'Black',
    dialNumerals: 'Roman numerals',
    name: 'Breguet Marine Big Date Black Dial Box+Papers 2008',
    bezelMaterial: 'Steel',
    crystal: 'Sapphire crystal',
    published: true,
    url: 'https://www.chrono24.com/breguet/breguet-marine-big-date-black-dial-boxpapers-2008--id23527445.htm',
  },
  {
    createdAt: '2022-06-10T06:00:21.8081609',
    modifiedAt: '2022-11-01T13:23:01.5249137',
    tags: [],
    images: [
      {
        url: 'https://ucarecdn.com/10a117fc-dd85-4165-bdb2-8c3e936e8577/-/preview/1000x1000/-/format/webp/Breguet-Breguet Marine Big Date Chronograph Box+Papers-5827BR-Z2-5ZU.jpeg',
        fileName: null,
        path: null,
        containerName: null,
      },
      {
        url: 'https://ucarecdn.com/300094b0-eec0-4c8d-ae1b-56a09d77be19/-/preview/1000x1000/-/format/webp/Breguet-Breguet Marine Big Date Chronograph Box+Papers-5827BR-Z2-5ZU.jpeg',
        fileName: null,
        path: null,
        containerName: null,
      },
      {
        url: 'https://ucarecdn.com/74b4cdfd-55ed-4484-aa46-31094b9d4cbd/-/preview/1000x1000/-/format/webp/Breguet-Breguet Marine Big Date Chronograph Box+Papers-5827BR-Z2-5ZU.jpeg',
        fileName: null,
        path: null,
        containerName: null,
      },
      {
        url: 'https://ucarecdn.com/e9c96431-a9f6-4734-94d5-7d584d07e136/-/preview/1000x1000/-/format/webp/Breguet-Breguet Marine Big Date Chronograph Box+Papers-5827BR-Z2-5ZU.jpeg',
        fileName: null,
        path: null,
        containerName: null,
      },
      {
        url: 'https://ucarecdn.com/053f157c-1861-4327-9fc8-fad07f443a10/-/preview/1000x1000/-/format/webp/Breguet-Breguet Marine Big Date Chronograph Box+Papers-5827BR-Z2-5ZU.jpeg',
        fileName: null,
        path: null,
        containerName: null,
      },
      {
        url: 'https://ucarecdn.com/e3290885-504e-4b78-a5f1-9d1450c7c5d3/-/preview/1000x1000/-/format/webp/Breguet-Breguet Marine Big Date Chronograph Box+Papers-5827BR-Z2-5ZU.jpeg',
        fileName: null,
        path: null,
        containerName: null,
      },
      {
        url: 'https://ucarecdn.com/a343776e-873f-4b3b-bd64-7d90895ed28f/-/preview/1000x1000/-/format/webp/Breguet-Breguet Marine Big Date Chronograph Box+Papers-5827BR-Z2-5ZU.jpeg',
        fileName: null,
        path: null,
        containerName: null,
      },
      {
        url: 'https://ucarecdn.com/8135fa1c-cb21-49fe-a88f-cc1f31bd88fb/-/preview/1000x1000/-/format/webp/Breguet-Breguet Marine Big Date Chronograph Box+Papers-5827BR-Z2-5ZU.jpeg',
        fileName: null,
        path: null,
        containerName: null,
      },
    ],
    documents: [],
    model: {
      createdAt: '2022-06-10T06:00:21.8075326',
      modifiedAt: '2022-06-10T06:00:21.8075326',
      brand: {
        createdAt: '2022-06-10T06:00:21.8075021',
        modifiedAt: '2022-06-10T06:00:21.8075021',
        fileLogoImage: null,
        fileImage: null,
        id: '5992ed37-b9a2-4074-0f67-08da4aa68096',
        name: 'Breguet',
        title: '',
        description: '',
        stringImage: null,
        stringLogoImage: null,
      },
      fileImage: null,
      id: 'ba3a127a-5722-4078-6634-08da4aa6809a',
      brandId: '591a398d-764c-445e-2bc0-08da5d9850d6',
      name: 'Marine',
      stringImage: null,
    },
    id: '23550006-e1f8-459a-9e79-08da4aa6809c',
    modelId: 'ba3a127a-5722-4078-6634-08da4aa6809a',
    price: 21200,
    availability: 'InStock',
    caseDiameter: '42 mm',
    refNumber: '5827BR/Z2/5ZU',
    movement: 'Automatic',
    braceletMaterial: 'Rubber',
    braceletColor: 'Black',
    clasp: 'Fold clasp',
    claspMaterial: 'Rose Gold',
    description: '',
    dealerProductCode: '1010N3750',
    caseMaterial: 'Rose gold',
    yearProduction: '',
    condition: 'Very good\n                     (Worn with little to no signs of wear)',
    scopeDelivery: 'Original box, original papers',
    dial: 'Black',
    dialNumerals: 'Roman numerals',
    name: 'Breguet Marine Date Chronograph Box+Papers',
    bezelMaterial: 'Rose gold',
    crystal: 'Sapphire crystal',
    published: true,
    url: 'https://www.chrono24.com/breguet/breguet-marine-date-chronograph-boxpapers--id23640395.htm',
  },
  {
    createdAt: '2022-06-10T06:00:21.8078462',
    modifiedAt: '2022-11-01T13:22:38.6580754',
    tags: [],
    images: [
      {
        url: 'https://ucarecdn.com/4488b356-65b7-4d17-a385-7d7825a99d6f/-/preview/1000x1000/-/format/webp/Breguet-Breguet Classique-5177BB-29-9V6.jpeg',
        fileName: null,
        path: null,
        containerName: null,
      },
      {
        url: 'https://ucarecdn.com/2791bd18-9ff8-451e-8e5d-2037f2dd4637/-/preview/1000x1000/-/format/webp/Breguet-Breguet Classique-5177BB-29-9V6.jpeg',
        fileName: null,
        path: null,
        containerName: null,
      },
      {
        url: 'https://ucarecdn.com/1b9ba052-0065-49b4-bb4d-357a60735be3/-/preview/1000x1000/-/format/webp/Breguet-Breguet Classique-5177BB-29-9V6.jpeg',
        fileName: null,
        path: null,
        containerName: null,
      },
      {
        url: 'https://ucarecdn.com/b431722f-bfaf-4eb4-b394-20260e266615/-/preview/1000x1000/-/format/webp/Breguet-Breguet Classique-5177BB-29-9V6.jpeg',
        fileName: null,
        path: null,
        containerName: null,
      },
      {
        url: 'https://ucarecdn.com/ed8df613-0a52-4b6f-84c4-fe4d8b874bff/-/preview/1000x1000/-/format/webp/Breguet-Breguet Classique-5177BB-29-9V6.jpeg',
        fileName: null,
        path: null,
        containerName: null,
      },
      {
        url: 'https://ucarecdn.com/9d00c891-82af-4da8-b7c7-00f093112b39/-/preview/1000x1000/-/format/webp/Breguet-Breguet Classique-5177BB-29-9V6.jpeg',
        fileName: null,
        path: null,
        containerName: null,
      },
      {
        url: 'https://ucarecdn.com/95c32e3a-67ac-4791-87b0-18a986071352/-/preview/1000x1000/-/format/webp/Breguet-Breguet Classique-5177BB-29-9V6.jpeg',
        fileName: null,
        path: null,
        containerName: null,
      },
      {
        url: 'https://ucarecdn.com/e9fd2b3f-9197-4cfd-9817-c631834b5f12/-/preview/1000x1000/-/format/webp/Breguet-Breguet Classique-5177BB-29-9V6.jpeg',
        fileName: null,
        path: null,
        containerName: null,
      },
    ],
    documents: [],
    model: {
      createdAt: '2022-06-10T06:00:21.8075099',
      modifiedAt: '2022-06-10T06:00:21.8075099',
      brand: {
        createdAt: '2022-06-10T06:00:21.8075021',
        modifiedAt: '2022-06-10T06:00:21.8075021',
        fileLogoImage: null,
        fileImage: null,
        id: '5992ed37-b9a2-4074-0f67-08da4aa68096',
        name: 'Breguet',
        title: '',
        description: '',
        stringImage: null,
        stringLogoImage: null,
      },
      fileImage: null,
      id: 'c2ab7170-2d5d-4d32-6631-08da4aa6809a',
      brandId: '591a398d-764c-445e-2bc0-08da5d9850d6',
      name: 'Classique',
      stringImage: null,
    },
    id: '2964389b-416a-4236-9e4e-08da4aa6809c',
    modelId: 'c2ab7170-2d5d-4d32-6631-08da4aa6809a',
    price: 14100,
    availability: 'InStock',
    caseDiameter: '38 mm',
    refNumber: '5177BB/29/9V6',
    movement: 'Automatic',
    braceletMaterial: 'Crocodile skin',
    braceletColor: 'Black',
    clasp: 'Buckle',
    claspMaterial: 'White Gold',
    description: '',
    dealerProductCode: '@1010N3771',
    caseMaterial: 'White gold',
    yearProduction: '',
    condition: 'Very good\n                     (Worn with little to no signs of wear)',
    scopeDelivery: 'Original box, no original papers',
    dial: 'White',
    dialNumerals: 'Arabic numerals',
    name: 'Breguet Classique 5177BB/29/9V6',
    bezelMaterial: 'White gold',
    crystal: 'Sapphire crystal',
    published: true,
    url: 'https://www.chrono24.com/breguet/breguet-classique--id20322566.htm',
  },

  {
    createdAt: '2022-06-10T06:00:21.8084311',
    modifiedAt: '2022-11-01T13:24:23.1204161',
    tags: [],
    images: [
      {
        url: 'https://ucarecdn.com/1c5470b9-cdac-4a1c-a2f0-37d186ae4095/-/preview/1000x1000/-/format/webp/Patek Philippe-Patek Philippe Gondolo 5111G-001-5111G-001',
        fileName: null,
        path: null,
        containerName: null,
      },
    ],
    documents: [],
    model: {
      createdAt: '2022-06-10T06:00:21.8079614',
      modifiedAt: '2022-06-10T06:00:21.8079614',
      brand: {
        createdAt: '2022-06-10T06:00:21.8075425',
        modifiedAt: '2022-06-10T06:00:21.8075425',
        fileLogoImage: null,
        fileImage: null,
        id: '19c5dc9d-ef62-4c11-0f69-08da4aa68096',
        name: 'Patek Philippe',
        title: '',
        description: '',
        stringImage: null,
        stringLogoImage: null,
      },
      fileImage: null,
      id: '54cc7f25-8914-4e26-6661-08da4aa6809a',
      brandId: '19c5dc9d-ef62-4c11-0f69-08da4aa68096',
      name: 'Gondolo',
      stringImage: null,
    },
    id: '5a386bc5-ac88-49e7-9ea3-08da4aa6809c',
    modelId: '54cc7f25-8914-4e26-6661-08da4aa6809a',
    price: 13700,
    availability: 'InStock',
    caseDiameter: '32.9 x 47.8 mm',
    refNumber: '5111G-001',
    movement: 'Manual winding',
    braceletMaterial: 'Crocodile skin',
    braceletColor: 'Brown',
    clasp: 'Buckle',
    claspMaterial: 'White Gold',
    description: '',
    dealerProductCode: '1010N2568',
    caseMaterial: 'White gold',
    yearProduction: '',
    condition: 'Very good\n                     (Worn with little to no signs of wear)',
    scopeDelivery: 'Original box, no original papers',
    dial: 'Silver',
    dialNumerals: '',
    name: 'Patek Philippe Gondolo 5111G-001',
    bezelMaterial: 'White gold',
    crystal: 'Sapphire crystal',
    published: true,
    url: 'https://www.chrono24.com/patekphilippe/patek-philippe-gondolo--id18364970.htm',
  },
  {
    createdAt: '2022-06-10T06:00:21.8095985',
    modifiedAt: '2022-11-01T13:25:19.646503',
    tags: [],
    images: [
      {
        url: 'https://ucarecdn.com/da142485-bb88-4c3a-aa62-1004fa66abd4/-/preview/1000x1000/-/format/webp/Patek Philippe-Patek Philippe Travel Time Box + Extract from Archives 2005-5134 R-001.jpeg',
        fileName: null,
        path: null,
        containerName: null,
      },
      {
        url: 'https://ucarecdn.com/8b7f8e00-7008-43fa-9fde-cede957dea5b/-/preview/1000x1000/-/format/webp/Patek Philippe-Patek Philippe Travel Time Box + Extract from Archives 2005-5134 R-001.jpeg',
        fileName: null,
        path: null,
        containerName: null,
      },
      {
        url: 'https://ucarecdn.com/852973dd-463c-463b-9120-e7e8df506f74/-/preview/1000x1000/-/format/webp/Patek Philippe-Patek Philippe Travel Time Box + Extract from Archives 2005-5134 R-001.jpeg',
        fileName: null,
        path: null,
        containerName: null,
      },
      {
        url: 'https://ucarecdn.com/880cdcf6-c36a-40b8-ae3c-dff760078199/-/preview/1000x1000/-/format/webp/Patek Philippe-Patek Philippe Travel Time Box + Extract from Archives 2005-5134 R-001.jpeg',
        fileName: null,
        path: null,
        containerName: null,
      },
      {
        url: 'https://ucarecdn.com/dfb780fc-6574-470b-8449-07bf3b407d93/-/preview/1000x1000/-/format/webp/Patek Philippe-Patek Philippe Travel Time Box + Extract from Archives 2005-5134 R-001.jpeg',
        fileName: null,
        path: null,
        containerName: null,
      },
      {
        url: 'https://ucarecdn.com/925fdd05-e91b-4798-b930-cec32b03a751/-/preview/1000x1000/-/format/webp/Patek Philippe-Patek Philippe Travel Time Box + Extract from Archives 2005-5134 R-001.jpeg',
        fileName: null,
        path: null,
        containerName: null,
      },
    ],
    documents: [],
    model: {
      createdAt: '2022-06-10T06:00:21.809595',
      modifiedAt: '2022-06-10T06:00:21.809595',
      brand: {
        createdAt: '2022-06-10T06:00:21.8075425',
        modifiedAt: '2022-06-10T06:00:21.8075425',
        fileLogoImage: null,
        fileImage: null,
        id: '19c5dc9d-ef62-4c11-0f69-08da4aa68096',
        name: 'Patek Philippe',
        title: '',
        description: '',
        stringImage: null,
        stringLogoImage: null,
      },
      fileImage: null,
      id: '0c859b13-b372-4838-66eb-08da4aa6809a',
      brandId: '19c5dc9d-ef62-4c11-0f69-08da4aa68096',
      name: 'Travel Time',
      stringImage: null,
    },
    id: 'b424f227-7777-4730-9f55-08da4aa6809c',
    modelId: '0c859b13-b372-4838-66eb-08da4aa6809a',
    price: 23700,
    availability: 'InStock',
    caseDiameter: '37 mm',
    refNumber: '5134 R-001',
    movement: 'Manual winding',
    braceletMaterial: 'Crocodile skin',
    braceletColor: '',
    clasp: '',
    claspMaterial: '',
    description: '',
    dealerProductCode: '1010N3489',
    caseMaterial: 'Rose gold',
    yearProduction: '2005',
    condition: 'Very good\n                     (Worn with little to no signs of wear)',
    scopeDelivery: 'Original box, original papers',
    dial: 'White',
    dialNumerals: '',
    name: 'Patek Philippe Travel Time Box + Extract from Archives 2005',
    bezelMaterial: '',
    crystal: '',
    published: true,
    url: 'https://www.chrono24.com/patekphilippe/patek-philippe-travel-time-box--extract-from-archives-2005--id21290989.htm',
  },
  {
    createdAt: '2022-06-10T06:00:21.8093985',
    modifiedAt: '2022-11-01T13:25:53.7518574',
    tags: [],
    images: [
      {
        url: 'https://ucarecdn.com/2fbf29f5-71e5-4ddb-badc-93e5e4a864db/-/preview/1000x1000/-/format/webp/Patek Philippe-Patek Philippe Gondolo Box+Papers 2006-5135G-010.jpeg',
        fileName: null,
        path: null,
        containerName: null,
      },
      {
        url: 'https://ucarecdn.com/a8b5a3bc-c0c8-4889-9c7a-0d6ba136c998/-/preview/1000x1000/-/format/webp/Patek Philippe-Patek Philippe Gondolo Box+Papers 2006-5135G-010.jpeg',
        fileName: null,
        path: null,
        containerName: null,
      },
      {
        url: 'https://ucarecdn.com/6d289b00-0cb6-45ae-af79-8b9bdea96c76/-/preview/1000x1000/-/format/webp/Patek Philippe-Patek Philippe Gondolo Box+Papers 2006-5135G-010.jpeg',
        fileName: null,
        path: null,
        containerName: null,
      },
      {
        url: 'https://ucarecdn.com/1769fcb1-b260-4dc1-867b-21a2c434c11f/-/preview/1000x1000/-/format/webp/Patek Philippe-Patek Philippe Gondolo Box+Papers 2006-5135G-010.jpeg',
        fileName: null,
        path: null,
        containerName: null,
      },
      {
        url: 'https://ucarecdn.com/92d11581-1436-46cb-875b-9e843c0c90e5/-/preview/1000x1000/-/format/webp/Patek Philippe-Patek Philippe Gondolo Box+Papers 2006-5135G-010.jpeg',
        fileName: null,
        path: null,
        containerName: null,
      },
      {
        url: 'https://ucarecdn.com/2e2b8fc8-9f22-4391-8f3f-2b4aa66f5440/-/preview/1000x1000/-/format/webp/Patek Philippe-Patek Philippe Gondolo Box+Papers 2006-5135G-010.jpeg',
        fileName: null,
        path: null,
        containerName: null,
      },
      {
        url: 'https://ucarecdn.com/726c803e-366d-4523-b16d-539f74e5d756/-/preview/1000x1000/-/format/webp/Patek Philippe-Patek Philippe Gondolo Box+Papers 2006-5135G-010.jpeg',
        fileName: null,
        path: null,
        containerName: null,
      },
      {
        url: 'https://ucarecdn.com/09fb63f3-bbf8-4d73-85f6-5c9c852d452d/-/preview/1000x1000/-/format/webp/Patek Philippe-Patek Philippe Gondolo Box+Papers 2006-5135G-010.jpeg',
        fileName: null,
        path: null,
        containerName: null,
      },
      {
        url: 'https://ucarecdn.com/5bfdeadf-a134-421f-be61-5ff64e3370ed/-/preview/1000x1000/-/format/webp/Patek Philippe-Patek Philippe Gondolo Box+Papers 2006-5135G-010.jpeg',
        fileName: null,
        path: null,
        containerName: null,
      },
    ],
    documents: [],
    model: {
      createdAt: '2022-06-10T06:00:21.8079614',
      modifiedAt: '2022-06-10T06:00:21.8079614',
      brand: {
        createdAt: '2022-06-10T06:00:21.8075425',
        modifiedAt: '2022-06-10T06:00:21.8075425',
        fileLogoImage: null,
        fileImage: null,
        id: '19c5dc9d-ef62-4c11-0f69-08da4aa68096',
        name: 'Patek Philippe',
        title: '',
        description: '',
        stringImage: null,
        stringLogoImage: null,
      },
      fileImage: null,
      id: '54cc7f25-8914-4e26-6661-08da4aa6809a',
      brandId: '19c5dc9d-ef62-4c11-0f69-08da4aa68096',
      name: 'Gondolo',
      stringImage: null,
    },
    id: '5aec1f5d-b1a8-46c8-9f35-08da4aa6809c',
    modelId: '54cc7f25-8914-4e26-6661-08da4aa6809a',
    price: 34100,
    availability: 'InStock',
    caseDiameter: '51 x 38 mm',
    refNumber: '5135G-010',
    movement: 'Automatic',
    braceletMaterial: 'Crocodile skin',
    braceletColor: 'Brown',
    clasp: 'Buckle',
    claspMaterial: 'White Gold',
    description: '',
    dealerProductCode: '@1010N3747',
    caseMaterial: 'White gold',
    yearProduction: '',
    condition: 'Very good\n                     (Worn with little to no signs of wear)',
    scopeDelivery: 'Original box, original papers',
    dial: 'Grey',
    dialNumerals: 'Arabic numerals',
    name: 'Patek Philippe Gondolo Box+Papers 2006',
    bezelMaterial: 'White gold',
    crystal: 'Sapphire crystal',
    published: true,
    url: 'https://www.chrono24.com/patekphilippe/patek-philippe-gondolo-boxpapers-2006--id23526703.htm',
  },
  {
    createdAt: '2022-10-18T18:59:07.662581',
    modifiedAt: '2022-11-01T13:25:39.7913291',
    tags: [],
    images: [
      {
        url: 'https://ucarecdn.com/83a9ffaa-7893-455f-8a32-5b721ec59872/-/preview/1000x1000/-/format/webp/Patek Philippe-Patek Philippe World Time 5110G-001-5110G-001',
        fileName: null,
        path: null,
        containerName: null,
      },
      {
        url: 'https://ucarecdn.com/3addfaa6-96f2-4f38-b09d-0ddecd9dfdc9/-/preview/1000x1000/-/format/webp/Patek Philippe-Patek Philippe World Time 5110G-001-5110G-001',
        fileName: null,
        path: null,
        containerName: null,
      },
      {
        url: 'https://ucarecdn.com/887f5486-2205-461e-8fc0-f338e9d7fee9/-/preview/1000x1000/-/format/webp/Patek Philippe-Patek Philippe World Time 5110G-001-5110G-001',
        fileName: null,
        path: null,
        containerName: null,
      },
      {
        url: 'https://ucarecdn.com/73f99907-e03e-4b0f-89da-17e4288a5c5b/-/preview/1000x1000/-/format/webp/Patek Philippe-Patek Philippe World Time 5110G-001-5110G-001',
        fileName: null,
        path: null,
        containerName: null,
      },
    ],
    documents: [],
    model: {
      createdAt: '2022-06-10T06:00:21.8081532',
      modifiedAt: '2022-06-10T06:00:21.8081532',
      brand: {
        createdAt: '2022-06-10T06:00:21.8075425',
        modifiedAt: '2022-06-10T06:00:21.8075425',
        fileLogoImage: null,
        fileImage: null,
        id: '19c5dc9d-ef62-4c11-0f69-08da4aa68096',
        name: 'Patek Philippe',
        title: '',
        description: '',
        stringImage: null,
        stringLogoImage: null,
      },
      fileImage: null,
      id: '5435e711-860d-4fb3-6671-08da4aa6809a',
      brandId: '19c5dc9d-ef62-4c11-0f69-08da4aa68096',
      name: 'World Time',
      stringImage: null,
    },
    id: '7a588672-d88e-4311-e72b-08da9b57b2bd',
    modelId: '5435e711-860d-4fb3-6671-08da4aa6809a',
    price: 39900,
    availability: 'InStock',
    caseDiameter: '37 mm',
    refNumber: '5110G-001',
    movement: 'Automatic',
    braceletMaterial: 'Crocodile skin',
    braceletColor: 'Black',
    clasp: 'Fold clasp',
    claspMaterial: 'White Gold',
    description: '',
    dealerProductCode: '1010N4324',
    caseMaterial: 'White gold',
    yearProduction: '',
    condition: 'Very good\n                     (Worn with little to no signs of wear)',
    scopeDelivery: 'Original box, no original papers',
    dial: 'Silver',
    dialNumerals: '',
    name: 'Patek Philippe World Time 5110G-001',
    bezelMaterial: 'White gold',
    crystal: 'Sapphire crystal',
    published: true,
    url: 'https://www.chrono24.com/patekphilippe/patek-philippe-world-time--id25763640.htm',
  },

  {
    createdAt: '2022-06-10T06:00:21.8087724',
    modifiedAt: '2022-11-01T13:28:33.8955718',
    tags: [],
    images: [
      {
        url: 'https://ucarecdn.com/546a1ed6-90d1-44d2-ad64-2c7b66575f34/-/preview/1000x1000/-/format/webp/Vacheron Constantin-Vacheron Constantin Fiftysix Blue Dial Box + Extract from the archives 2019-4600E-110A-B487.jpeg',
        fileName: null,
        path: null,
        containerName: null,
      },
      {
        url: 'https://ucarecdn.com/dbb2af70-f1ee-4c0a-94a8-e4878215bbe7/-/preview/1000x1000/-/format/webp/Vacheron Constantin-Vacheron Constantin Fiftysix Blue Dial Box + Extract from the archives 2019-4600E-110A-B487.jpeg',
        fileName: null,
        path: null,
        containerName: null,
      },
      {
        url: 'https://ucarecdn.com/b065f192-9ca3-4e42-8934-424e846356d4/-/preview/1000x1000/-/format/webp/Vacheron Constantin-Vacheron Constantin Fiftysix Blue Dial Box + Extract from the archives 2019-4600E-110A-B487.jpeg',
        fileName: null,
        path: null,
        containerName: null,
      },
      {
        url: 'https://ucarecdn.com/70621e77-f75a-4080-92c6-00f962c1c2bf/-/preview/1000x1000/-/format/webp/Vacheron Constantin-Vacheron Constantin Fiftysix Blue Dial Box + Extract from the archives 2019-4600E-110A-B487.jpeg',
        fileName: null,
        path: null,
        containerName: null,
      },
      {
        url: 'https://ucarecdn.com/99f57755-ef2b-4ee9-a367-044987c43b9b/-/preview/1000x1000/-/format/webp/Vacheron Constantin-Vacheron Constantin Fiftysix Blue Dial Box + Extract from the archives 2019-4600E-110A-B487.jpeg',
        fileName: null,
        path: null,
        containerName: null,
      },
      {
        url: 'https://ucarecdn.com/981c7ff9-e32f-4589-821f-f743718e49e2/-/preview/1000x1000/-/format/webp/Vacheron Constantin-Vacheron Constantin Fiftysix Blue Dial Box + Extract from the archives 2019-4600E-110A-B487.jpeg',
        fileName: null,
        path: null,
        containerName: null,
      },
    ],
    documents: [],
    model: {
      createdAt: '2022-06-10T06:00:21.8087686',
      modifiedAt: '2022-06-10T06:00:21.8087686',
      brand: {
        createdAt: '2022-06-10T06:00:21.8075625',
        modifiedAt: '2022-06-10T06:00:21.8075625',
        fileLogoImage: null,
        fileImage: null,
        id: 'bafe575c-8902-46b8-0f6a-08da4aa68096',
        name: 'Vacheron Constantin',
        title: '',
        description: '',
        stringImage: null,
        stringLogoImage: null,
      },
      fileImage: null,
      id: 'cb216de0-7a29-403d-66a6-08da4aa6809a',
      brandId: 'bafe575c-8902-46b8-0f6a-08da4aa68096',
      name: 'Fiftysix',
      stringImage: null,
    },
    id: 'c55a5e26-469d-467d-9ed4-08da4aa6809c',
    modelId: 'cb216de0-7a29-403d-66a6-08da4aa6809a',
    price: 19300,
    availability: 'InStock',
    caseDiameter: '40 mm',
    refNumber: '4600E/110A-B487',
    movement: 'Manual winding',
    braceletMaterial: 'Steel',
    braceletColor: '',
    clasp: '',
    claspMaterial: '',
    description: '',
    dealerProductCode: '1010N3604',
    caseMaterial: 'Steel',
    yearProduction: '2019',
    condition: 'Very good\n                     (Worn with little to no signs of wear)',
    scopeDelivery: 'Original box, original papers',
    dial: 'Blue',
    dialNumerals: '',
    name: 'Vacheron Constantin Fiftysix Blue Dial Box + Extract from the archives 2019',
    bezelMaterial: '',
    crystal: '',
    published: true,
    url: 'https://www.chrono24.com/vacheronconstantin/vacheron-constantin-fiftysix-blue-dial-box--extract-from-the-archives-2019--id22521500.htm',
  },
  {
    createdAt: '2022-07-15T08:09:46.381612',
    modifiedAt: '2022-11-01T13:30:33.8997743',
    tags: [],
    images: [
      {
        url: 'https://ucarecdn.com/7d0a667c-55ec-4c86-821b-568a29a6e21a/-/preview/1000x1000/-/format/webp/Vacheron Constantin-Vacheron Constantin Overseas Dual Time Box-47450-B01A-9226.jpeg',
        fileName: null,
        path: null,
        containerName: null,
      },
      {
        url: 'https://ucarecdn.com/cac73d12-d7fb-45b3-b48c-04fe5ae85621/-/preview/1000x1000/-/format/webp/Vacheron Constantin-Vacheron Constantin Overseas Dual Time Box-47450-B01A-9226.jpeg',
        fileName: null,
        path: null,
        containerName: null,
      },
      {
        url: 'https://ucarecdn.com/b918440e-6d8c-4c7a-8883-746624c03a82/-/preview/1000x1000/-/format/webp/Vacheron Constantin-Vacheron Constantin Overseas Dual Time Box-47450-B01A-9226.jpeg',
        fileName: null,
        path: null,
        containerName: null,
      },
      {
        url: 'https://ucarecdn.com/e7379b0b-df8e-4145-b12f-7ee6a038bdc6/-/preview/1000x1000/-/format/webp/Vacheron Constantin-Vacheron Constantin Overseas Dual Time Box-47450-B01A-9226.jpeg',
        fileName: null,
        path: null,
        containerName: null,
      },
      {
        url: 'https://ucarecdn.com/da0be0fe-8dc9-4693-8e3f-8e9ba4ce01b3/-/preview/1000x1000/-/format/webp/Vacheron Constantin-Vacheron Constantin Overseas Dual Time Box-47450-B01A-9226.jpeg',
        fileName: null,
        path: null,
        containerName: null,
      },
      {
        url: 'https://ucarecdn.com/4e0f63f9-4e5a-4b04-8e11-9afbe93d45d3/-/preview/1000x1000/-/format/webp/Vacheron Constantin-Vacheron Constantin Overseas Dual Time Box-47450-B01A-9226.jpeg',
        fileName: null,
        path: null,
        containerName: null,
      },
    ],
    documents: [],
    model: {
      createdAt: '2022-06-10T06:00:21.8085569',
      modifiedAt: '2022-06-10T06:00:21.8085569',
      brand: {
        createdAt: '2022-06-10T06:00:21.8075625',
        modifiedAt: '2022-06-10T06:00:21.8075625',
        fileLogoImage: null,
        fileImage: null,
        id: 'bafe575c-8902-46b8-0f6a-08da4aa68096',
        name: 'Vacheron Constantin',
        title: '',
        description: '',
        stringImage: null,
        stringLogoImage: null,
      },
      fileImage: null,
      id: 'd4b0335f-d11a-4185-6692-08da4aa6809a',
      brandId: 'bafe575c-8902-46b8-0f6a-08da4aa68096',
      name: 'Overseas Dual Time',
      stringImage: null,
    },
    id: '603fb622-0fb4-47c4-e25b-08da656f5db3',
    modelId: 'd4b0335f-d11a-4185-6692-08da4aa6809a',
    price: 23400,
    availability: 'InStock',
    caseDiameter: '42 mm',
    refNumber: '47450/B01A-9226',
    movement: 'Automatic',
    braceletMaterial: 'Steel',
    braceletColor: 'Steel',
    clasp: 'Fold clasp',
    claspMaterial: 'Steel',
    description: '',
    dealerProductCode: '1010N3840',
    caseMaterial: 'Steel',
    yearProduction: '',
    condition: 'Very good\n                     (Worn with little to no signs of wear)',
    scopeDelivery: 'Original box, no original papers',
    dial: 'Silver',
    dialNumerals: 'No numerals',
    name: 'Vacheron Constantin Overseas Dual Time Box',
    bezelMaterial: 'Steel',
    crystal: 'Sapphire crystal',
    published: true,
    url: 'https://www.chrono24.com/vacheronconstantin/vacheron-constantin-overseas-dual-time-box--id24524249.htm',
  },
  {
    createdAt: '2022-06-10T06:00:21.8085607',
    modifiedAt: '2022-11-01T13:23:00.8417892',
    tags: [],
    images: [
      {
        url: 'https://ucarecdn.com/21fc5351-68cb-4a58-b5a6-b8989ee6cce5/-/preview/1000x1000/-/format/webp/Vacheron Constantin-Vacheron Constantin Overseas Dual Time Wempe Limited Edition ref. 47450-47450-B01A.jpeg',
        fileName: null,
        path: null,
        containerName: null,
      },
      {
        url: 'https://ucarecdn.com/8919559e-46cb-4381-b1ca-7dc36dc8266e/-/preview/1000x1000/-/format/webp/Vacheron Constantin-Vacheron Constantin Overseas Dual Time Wempe Limited Edition ref. 47450-47450-B01A.jpeg',
        fileName: null,
        path: null,
        containerName: null,
      },
      {
        url: 'https://ucarecdn.com/7f1f4cb4-acb1-44b4-82e1-ecfee85f1771/-/preview/1000x1000/-/format/webp/Vacheron Constantin-Vacheron Constantin Overseas Dual Time Wempe Limited Edition ref. 47450-47450-B01A.jpeg',
        fileName: null,
        path: null,
        containerName: null,
      },
      {
        url: 'https://ucarecdn.com/2aec3296-6edc-4102-8f8b-ae825ecc1bfa/-/preview/1000x1000/-/format/webp/Vacheron Constantin-Vacheron Constantin Overseas Dual Time Wempe Limited Edition ref. 47450-47450-B01A.jpeg',
        fileName: null,
        path: null,
        containerName: null,
      },
      {
        url: 'https://ucarecdn.com/752544d6-22ce-414e-bb63-a2c112d68247/-/preview/1000x1000/-/format/webp/Vacheron Constantin-Vacheron Constantin Overseas Dual Time Wempe Limited Edition ref. 47450-47450-B01A.jpeg',
        fileName: null,
        path: null,
        containerName: null,
      },
      {
        url: 'https://ucarecdn.com/99cfe13c-1b83-4e47-b031-3f920e00d78d/-/preview/1000x1000/-/format/webp/Vacheron Constantin-Vacheron Constantin Overseas Dual Time Wempe Limited Edition ref. 47450-47450-B01A.jpeg',
        fileName: null,
        path: null,
        containerName: null,
      },
      {
        url: 'https://ucarecdn.com/6de8aff0-f9e5-49f1-8e6e-2f91fa7f498f/-/preview/1000x1000/-/format/webp/Vacheron Constantin-Vacheron Constantin Overseas Dual Time Wempe Limited Edition ref. 47450-47450-B01A.jpeg',
        fileName: null,
        path: null,
        containerName: null,
      },
      {
        url: 'https://ucarecdn.com/b346e81c-5636-492e-9ee4-7f2c1edb3caf/-/preview/1000x1000/-/format/webp/Vacheron Constantin-Vacheron Constantin Overseas Dual Time Wempe Limited Edition ref. 47450-47450-B01A.jpeg',
        fileName: null,
        path: null,
        containerName: null,
      },
      {
        url: 'https://ucarecdn.com/77b48129-f9d3-4c76-a537-14e6256fd6f8/-/preview/1000x1000/-/format/webp/Vacheron Constantin-Vacheron Constantin Overseas Dual Time Wempe Limited Edition ref. 47450-47450-B01A.jpeg',
        fileName: null,
        path: null,
        containerName: null,
      },
    ],
    documents: [],
    model: {
      createdAt: '2022-06-10T06:00:21.8085569',
      modifiedAt: '2022-06-10T06:00:21.8085569',
      brand: {
        createdAt: '2022-06-10T06:00:21.8075625',
        modifiedAt: '2022-06-10T06:00:21.8075625',
        fileLogoImage: null,
        fileImage: null,
        id: 'bafe575c-8902-46b8-0f6a-08da4aa68096',
        name: 'Vacheron Constantin',
        title: '',
        description: '',
        stringImage: null,
        stringLogoImage: null,
      },
      fileImage: null,
      id: 'd4b0335f-d11a-4185-6692-08da4aa6809a',
      brandId: 'bafe575c-8902-46b8-0f6a-08da4aa68096',
      name: 'Overseas Dual Time',
      stringImage: null,
    },
    id: '29ae43e0-6884-4ebe-9eb5-08da4aa6809c',
    modelId: 'd4b0335f-d11a-4185-6692-08da4aa6809a',
    price: 25400,
    availability: 'InStock',
    caseDiameter: '42 mm',
    refNumber: '47450/B01A',
    movement: 'Automatic',
    braceletMaterial: 'Steel',
    braceletColor: '',
    clasp: '',
    claspMaterial: '',
    description: '',
    dealerProductCode: '1010N3822',
    caseMaterial: 'Steel',
    yearProduction: '',
    condition: 'Very good\n                     (Worn with little to no signs of wear)',
    scopeDelivery: 'Original box, no original papers',
    dial: 'Black',
    dialNumerals: '',
    name: 'Vacheron Constantin Overseas Dual Time Wempe Limited Edition ref. 47450',
    bezelMaterial: '',
    crystal: '',
    published: true,
    url: 'https://www.chrono24.com/vacheronconstantin/vacheron-constantin-overseas-dual-time-wempe-limited-edition-ref-47450--id23960139.htm',
  },
  {
    createdAt: '2022-06-10T06:00:21.808185',
    modifiedAt: '2022-11-01T13:31:52.9084045',
    tags: [],
    images: [
      {
        url: 'https://ucarecdn.com/330a9400-15c1-4330-89ad-438b3ccbec43/-/preview/1000x1000/-/format/webp/Vacheron Constantin-Vacheron Constantin Overseas Chronograph Blue Dial Full Set 2017-5500V-110A-B148.jpeg',
        fileName: null,
        path: null,
        containerName: null,
      },
      {
        url: 'https://ucarecdn.com/2a745ac7-754d-4052-8df5-821825327b86/-/preview/1000x1000/-/format/webp/Vacheron Constantin-Vacheron Constantin Overseas Chronograph Blue Dial Full Set 2017-5500V-110A-B148.jpeg',
        fileName: null,
        path: null,
        containerName: null,
      },
      {
        url: 'https://ucarecdn.com/b5a816e0-0cfe-440f-b144-e6f2f7eb5cbd/-/preview/1000x1000/-/format/webp/Vacheron Constantin-Vacheron Constantin Overseas Chronograph Blue Dial Full Set 2017-5500V-110A-B148.jpeg',
        fileName: null,
        path: null,
        containerName: null,
      },
      {
        url: 'https://ucarecdn.com/5cb970b4-329e-46b3-9f12-d08df5c49c1b/-/preview/1000x1000/-/format/webp/Vacheron Constantin-Vacheron Constantin Overseas Chronograph Blue Dial Full Set 2017-5500V-110A-B148.jpeg',
        fileName: null,
        path: null,
        containerName: null,
      },
      {
        url: 'https://ucarecdn.com/e41b6d05-d818-46e1-9c9e-0aacb3c0b1f3/-/preview/1000x1000/-/format/webp/Vacheron Constantin-Vacheron Constantin Overseas Chronograph Blue Dial Full Set 2017-5500V-110A-B148.jpeg',
        fileName: null,
        path: null,
        containerName: null,
      },
      {
        url: 'https://ucarecdn.com/ed0cd557-bc68-44e4-8788-b703dc363973/-/preview/1000x1000/-/format/webp/Vacheron Constantin-Vacheron Constantin Overseas Chronograph Blue Dial Full Set 2017-5500V-110A-B148.jpeg',
        fileName: null,
        path: null,
        containerName: null,
      },
    ],
    documents: [],
    model: {
      createdAt: '2022-06-10T06:00:21.8080485',
      modifiedAt: '2022-06-10T06:00:21.8080485',
      brand: {
        createdAt: '2022-06-10T06:00:21.8075625',
        modifiedAt: '2022-06-10T06:00:21.8075625',
        fileLogoImage: null,
        fileImage: null,
        id: 'bafe575c-8902-46b8-0f6a-08da4aa68096',
        name: 'Vacheron Constantin',
        title: '',
        description: '',
        stringImage: null,
        stringLogoImage: null,
      },
      fileImage: null,
      id: 'bf8ef388-e0ad-463c-6667-08da4aa6809a',
      brandId: 'bafe575c-8902-46b8-0f6a-08da4aa68096',
      name: 'Overseas Chronograph',
      stringImage: null,
    },
    id: 'e6cf6343-e1b5-42de-9e7e-08da4aa6809c',
    modelId: 'bf8ef388-e0ad-463c-6667-08da4aa6809a',
    price: 49300,
    availability: 'InStock',
    caseDiameter: '42.5 mm',
    refNumber: '5500V/110A-B148',
    movement: 'Automatic',
    braceletMaterial: 'Steel',
    braceletColor: 'Steel',
    clasp: 'Fold clasp',
    claspMaterial: 'Steel',
    description: '',
    dealerProductCode: '@1010N3555',
    caseMaterial: 'Steel',
    yearProduction: '2017',
    condition: 'Very good\n                     (Worn with little to no signs of wear)',
    scopeDelivery: 'Original box, original papers',
    dial: 'Blue',
    dialNumerals: 'No numerals',
    name: 'Vacheron Constantin Overseas Chronograph Blue Dial Full Set 2017',
    bezelMaterial: 'Steel',
    crystal: 'Sapphire crystal',
    published: true,
    url: 'https://www.chrono24.com/vacheronconstantin/vacheron-constantin-overseas-chronograph-blue-dial--full-set-2017--id22304398.htm',
  },

  {
    createdAt: '2022-06-10T06:00:21.8157364',
    modifiedAt: '2022-11-01T13:38:34.8048063',
    tags: [],
    images: [
      {
        url: 'https://ucarecdn.com/74546dbf-e8fe-467d-8bab-bdebb2fc7641/-/preview/1000x1000/-/format/webp/Rolex-Rolex Datejust 41 Blue Dial Box+Papers 2019-126334.jpeg',
        fileName: null,
        path: null,
        containerName: null,
      },
      {
        url: 'https://ucarecdn.com/08e2d4d0-3270-47d3-86f8-0217f6fdfd85/-/preview/1000x1000/-/format/webp/Rolex-Rolex Datejust 41 Blue Dial Box+Papers 2019-126334.jpeg',
        fileName: null,
        path: null,
        containerName: null,
      },
      {
        url: 'https://ucarecdn.com/a847d9af-91d5-41e3-83d0-b01227b573a0/-/preview/1000x1000/-/format/webp/Rolex-Rolex Datejust 41 Blue Dial Box+Papers 2019-126334.jpeg',
        fileName: null,
        path: null,
        containerName: null,
      },
      {
        url: 'https://ucarecdn.com/489dc9bb-36c9-41e7-bf00-b72981a4821a/-/preview/1000x1000/-/format/webp/Rolex-Rolex Datejust 41 Blue Dial Box+Papers 2019-126334.jpeg',
        fileName: null,
        path: null,
        containerName: null,
      },
      {
        url: 'https://ucarecdn.com/b8b33dec-cd28-4c6d-91c1-399812c1a5ac/-/preview/1000x1000/-/format/webp/Rolex-Rolex Datejust 41 Blue Dial Box+Papers 2019-126334.jpeg',
        fileName: null,
        path: null,
        containerName: null,
      },
      {
        url: 'https://ucarecdn.com/49be031e-1cd6-4278-9f8f-d9b57f4f0b5e/-/preview/1000x1000/-/format/webp/Rolex-Rolex Datejust 41 Blue Dial Box+Papers 2019-126334.jpeg',
        fileName: null,
        path: null,
        containerName: null,
      },
      {
        url: 'https://ucarecdn.com/f3dcc742-ffd1-4407-9198-d094b73e467d/-/preview/1000x1000/-/format/webp/Rolex-Rolex Datejust 41 Blue Dial Box+Papers 2019-126334.jpeg',
        fileName: null,
        path: null,
        containerName: null,
      },
    ],
    documents: [],
    model: {
      createdAt: '2022-06-10T06:00:21.8075249',
      modifiedAt: '2022-06-10T06:00:21.8075249',
      brand: {
        createdAt: '2022-06-10T06:00:21.8075175',
        modifiedAt: '2022-06-10T06:00:21.8075175',
        fileLogoImage: null,
        fileImage: null,
        id: '7088289d-eecc-4ab6-0f68-08da4aa68096',
        name: 'Rolex',
        title: '',
        description: '',
        stringImage: null,
        stringLogoImage: null,
      },
      fileImage: null,
      id: '00129ebc-616f-4fd2-6633-08da4aa6809a',
      brandId: '7088289d-eecc-4ab6-0f68-08da4aa68096',
      name: 'Datejust 41',
      stringImage: null,
    },
    id: '5a7b1078-abd6-4f08-a0fa-08da4aa6809c',
    modelId: '00129ebc-616f-4fd2-6633-08da4aa6809a',
    price: 13400,
    availability: 'InStock',
    caseDiameter: '41 mm',
    refNumber: '126334',
    movement: 'Automatic',
    braceletMaterial: 'Steel',
    braceletColor: 'Steel',
    clasp: 'Fold clasp',
    claspMaterial: 'Steel',
    description: '',
    dealerProductCode: '1010N3617',
    caseMaterial: 'Steel',
    yearProduction: '2019',
    condition: 'Very good\n                     (Worn with little to no signs of wear)',
    scopeDelivery: 'Original box, original papers',
    dial: 'Blue',
    dialNumerals: 'Roman numerals',
    name: 'Rolex Datejust 41 Blue Dial Box+Papers 2019',
    bezelMaterial: 'White gold',
    crystal: 'Sapphire crystal',
    published: true,
    url: 'https://www.chrono24.com/rolex/rolex-datejust-41-blue-dial--boxpapers-2019--id23349817.htm',
  },
  {
    createdAt: '2022-08-22T22:30:24.162609',
    modifiedAt: '2022-11-01T13:26:50.4414948',
    tags: [],
    images: [
      {
        url: 'https://ucarecdn.com/3712bedb-afb5-48e3-976f-77a22943fb90/-/preview/1000x1000/-/format/webp/Rolex-Rolex Milgauss-116400GV',
        fileName: null,
        path: null,
        containerName: null,
      },
      {
        url: 'https://ucarecdn.com/4d5a416d-5d10-4a14-ad08-f542d49c9450/-/preview/1000x1000/-/format/webp/Rolex-Rolex Milgauss-116400GV',
        fileName: null,
        path: null,
        containerName: null,
      },
      {
        url: 'https://ucarecdn.com/b99b748d-a088-4df1-bf02-27a1fe2bb8ab/-/preview/1000x1000/-/format/webp/Rolex-Rolex Milgauss-116400GV',
        fileName: null,
        path: null,
        containerName: null,
      },
      {
        url: 'https://ucarecdn.com/16c5bfc0-748f-49a5-b842-05190b6aade5/-/preview/1000x1000/-/format/webp/Rolex-Rolex Milgauss-116400GV',
        fileName: null,
        path: null,
        containerName: null,
      },
      {
        url: 'https://ucarecdn.com/16ba676a-68cb-4723-83db-44027ad0e413/-/preview/1000x1000/-/format/webp/Rolex-Rolex Milgauss-116400GV',
        fileName: null,
        path: null,
        containerName: null,
      },
      {
        url: 'https://ucarecdn.com/d136dc90-748a-4460-976d-d02abea0fff7/-/preview/1000x1000/-/format/webp/Rolex-Rolex Milgauss-116400GV',
        fileName: null,
        path: null,
        containerName: null,
      },
      {
        url: 'https://ucarecdn.com/5446cafe-4fa9-4b34-8dd5-969c84582a6f/-/preview/1000x1000/-/format/webp/Rolex-Rolex Milgauss-116400GV',
        fileName: null,
        path: null,
        containerName: null,
      },
      {
        url: 'https://ucarecdn.com/aaee0e2a-b2a1-445e-a37a-661dc15de4ec/-/preview/1000x1000/-/format/webp/Rolex-Rolex Milgauss-116400GV',
        fileName: null,
        path: null,
        containerName: null,
      },
    ],
    documents: [],
    model: {
      createdAt: '2022-06-10T06:00:21.8091332',
      modifiedAt: '2022-06-10T06:00:21.8091332',
      brand: {
        createdAt: '2022-06-10T06:00:21.8075175',
        modifiedAt: '2022-06-10T06:00:21.8075175',
        fileLogoImage: null,
        fileImage: null,
        id: '7088289d-eecc-4ab6-0f68-08da4aa68096',
        name: 'Rolex',
        title: '',
        description: '',
        stringImage: null,
        stringLogoImage: null,
      },
      fileImage: null,
      id: '78c8ca32-b4a4-4eb7-66c5-08da4aa6809a',
      brandId: '7088289d-eecc-4ab6-0f68-08da4aa68096',
      name: 'Milgauss',
      stringImage: null,
    },
    id: '160f352b-8c90-46be-7b42-08da7fd6ea54',
    modelId: '78c8ca32-b4a4-4eb7-66c5-08da4aa6809a',
    price: 11800,
    availability: 'InStock',
    caseDiameter: '40 mm',
    refNumber: '116400GV',
    movement: 'Automatic',
    braceletMaterial: 'Steel',
    braceletColor: 'Steel',
    clasp: 'Fold clasp',
    claspMaterial: 'Steel',
    description: '',
    dealerProductCode: '1010K3849',
    caseMaterial: 'Steel',
    yearProduction: '',
    condition: 'Very good\n                     (Worn with little to no signs of wear)',
    scopeDelivery: 'Original box, no original papers',
    dial: 'Black',
    dialNumerals: 'No numerals',
    name: 'Rolex Milgauss 116400GV',
    bezelMaterial: 'Steel',
    crystal: 'Sapphire crystal',
    published: true,
    url: 'https://www.chrono24.com/rolex/rolex-milgauss--id23984982.htm',
  },
  {
    createdAt: '2022-06-10T06:00:21.8087996',
    modifiedAt: '2022-11-01T13:24:51.9089571',
    tags: [],
    images: [
      {
        url: 'https://ucarecdn.com/71db2e24-6f66-47e8-851a-ddb2602e8400/-/preview/1000x1000/-/format/webp/Rolex-Rolex Sky-Dweller box and papers 2018-326934',
        fileName: null,
        path: null,
        containerName: null,
      },
    ],
    documents: [],
    model: {
      createdAt: '2022-06-10T06:00:21.8087961',
      modifiedAt: '2022-06-10T06:00:21.8087961',
      brand: {
        createdAt: '2022-06-10T06:00:21.8075175',
        modifiedAt: '2022-06-10T06:00:21.8075175',
        fileLogoImage: null,
        fileImage: null,
        id: '7088289d-eecc-4ab6-0f68-08da4aa68096',
        name: 'Rolex',
        title: '',
        description: '',
        stringImage: null,
        stringLogoImage: null,
      },
      fileImage: null,
      id: '4668b23b-3d57-4fef-66a8-08da4aa6809a',
      brandId: '7088289d-eecc-4ab6-0f68-08da4aa68096',
      name: 'Sky-Dweller',
      stringImage: null,
    },
    id: '53c65fb9-6b65-4122-9ed9-08da4aa6809c',
    modelId: '4668b23b-3d57-4fef-66a8-08da4aa6809a',
    price: 29500,
    availability: 'InStock',
    caseDiameter: '42 mm',
    refNumber: '326934',
    movement: 'Automatic',
    braceletMaterial: 'Steel',
    braceletColor: 'Steel',
    clasp: 'Fold clasp',
    claspMaterial: 'Steel',
    description: '',
    dealerProductCode: '1010N3696',
    caseMaterial: 'Steel',
    yearProduction: '2018',
    condition: 'Very good\n                     (Worn with little to no signs of wear)',
    scopeDelivery: 'Original box, original papers',
    dial: 'Blue',
    dialNumerals: 'No numerals',
    name: 'Rolex Sky-Dweller box and papers 2018',
    bezelMaterial: 'White gold',
    crystal: 'Sapphire crystal',
    published: true,
    url: 'https://www.chrono24.com/rolex/rolex-sky-dweller-box-and-papers-2018--id22995276.htm',
  },
  {
    createdAt: '2022-08-27T22:30:10.9827577',
    modifiedAt: '2022-11-01T13:24:12.8516473',
    tags: [],
    images: [
      {
        url: 'https://ucarecdn.com/793fc596-5452-4e59-b2f6-84f1d7e13c48/-/preview/1000x1000/-/format/webp/Rolex-Rolex Daytona APH dial (Full Set 2016)-116520',
        fileName: null,
        path: null,
        containerName: null,
      },
      {
        url: 'https://ucarecdn.com/cb5239d8-b5af-4661-9559-72a346ff2ca5/-/preview/1000x1000/-/format/webp/Rolex-Rolex Daytona APH dial (Full Set 2016)-116520',
        fileName: null,
        path: null,
        containerName: null,
      },
      {
        url: 'https://ucarecdn.com/4311d85d-75c4-4bcc-86f2-9c512d521367/-/preview/1000x1000/-/format/webp/Rolex-Rolex Daytona APH dial (Full Set 2016)-116520',
        fileName: null,
        path: null,
        containerName: null,
      },
      {
        url: 'https://ucarecdn.com/ced3f3af-8ac7-41e6-aee4-17dab909a1bb/-/preview/1000x1000/-/format/webp/Rolex-Rolex Daytona APH dial (Full Set 2016)-116520',
        fileName: null,
        path: null,
        containerName: null,
      },
      {
        url: 'https://ucarecdn.com/83c2a558-32dd-4c5f-b2bd-daacc82b39e3/-/preview/1000x1000/-/format/webp/Rolex-Rolex Daytona APH dial (Full Set 2016)-116520',
        fileName: null,
        path: null,
        containerName: null,
      },
    ],
    documents: [],
    model: {
      createdAt: '2022-06-10T06:00:21.8086465',
      modifiedAt: '2022-06-10T06:00:21.8086465',
      brand: {
        createdAt: '2022-06-10T06:00:21.8075175',
        modifiedAt: '2022-06-10T06:00:21.8075175',
        fileLogoImage: null,
        fileImage: null,
        id: '7088289d-eecc-4ab6-0f68-08da4aa68096',
        name: 'Rolex',
        title: '',
        description: '',
        stringImage: null,
        stringLogoImage: null,
      },
      fileImage: null,
      id: 'db413a0e-a725-471f-669b-08da4aa6809a',
      brandId: '7088289d-eecc-4ab6-0f68-08da4aa68096',
      name: 'Daytona',
      stringImage: null,
    },
    id: '2d5163f2-08ca-4102-7b59-08da7fd6ea54',
    modelId: 'db413a0e-a725-471f-669b-08da4aa6809a',
    price: 33900,
    availability: 'InStock',
    caseDiameter: '40 mm',
    refNumber: '116520',
    movement: 'Automatic',
    braceletMaterial: 'Steel',
    braceletColor: 'Steel',
    clasp: 'Fold clasp',
    claspMaterial: 'Steel',
    description: '',
    dealerProductCode: '1010N4158',
    caseMaterial: 'Steel',
    yearProduction: '2016',
    condition: 'Very good\n                     (Worn with little to no signs of wear)',
    scopeDelivery: 'Original box, original papers',
    dial: 'White',
    dialNumerals: 'No numerals',
    name: 'Rolex Daytona APH dial (Full Set 2016)',
    bezelMaterial: 'Steel',
    crystal: 'Sapphire crystal',
    published: true,
    url: 'https://www.chrono24.com/rolex/rolex-daytona-aph-dial-full-set-2016--id25177156.htm',
  },
  {
    createdAt: '0001-01-01T00:00:00',
    modifiedAt: '2022-11-01T13:30:56.2538044',
    tags: [
      {
        createdAt: '0001-01-01T00:00:00',
        modifiedAt: '0001-01-01T00:00:00',
        id: '097d9e1f-f405-4bb5-9f45-14ab38bb835d',
        name: 'Top',
      },
    ],
    images: [
      {
        url: 'https://ucarecdn.com/3fa56a31-44e2-47ec-bd58-c8a240c49b64/-/preview/1000x1000/-/format/webp/F.P.Journe-F.P.Journe Octa Jour et Nuit Ruthenium-Platinum series, 99 pcs LE Box+Extract from the archives 2003-octa',
        fileName: null,
        path: null,
        containerName: null,
      },
      {
        url: 'https://ucarecdn.com/b64428cf-8dcb-457e-885c-aa995f20499b/-/preview/1000x1000/-/format/webp/F.P.Journe-F.P.Journe Octa Jour et Nuit Ruthenium-Platinum series, 99 pcs LE Box+Extract from the archives 2003-octa',
        fileName: null,
        path: null,
        containerName: null,
      },
      {
        url: 'https://ucarecdn.com/db646058-20c1-4e88-a7a8-ae5eb4861dd0/-/preview/1000x1000/-/format/webp/F.P.Journe-F.P.Journe Octa Jour et Nuit Ruthenium-Platinum series, 99 pcs LE Box+Extract from the archives 2003-octa',
        fileName: null,
        path: null,
        containerName: null,
      },
      {
        url: 'https://ucarecdn.com/a3df2dc1-4961-42a5-872b-0d964e0c5380/-/preview/1000x1000/-/format/webp/F.P.Journe-F.P.Journe Octa Jour et Nuit Ruthenium-Platinum series, 99 pcs LE Box+Extract from the archives 2003-octa',
        fileName: null,
        path: null,
        containerName: null,
      },
      {
        url: 'https://ucarecdn.com/828419ae-990c-4c37-b1d7-9da98596ba42/-/preview/1000x1000/-/format/webp/F.P.Journe-F.P.Journe Octa Jour et Nuit Ruthenium-Platinum series, 99 pcs LE Box+Extract from the archives 2003-octa',
        fileName: null,
        path: null,
        containerName: null,
      },
      {
        url: 'https://ucarecdn.com/9af402dc-302f-4835-813f-f15acb7536f4/-/preview/1000x1000/-/format/webp/F.P.Journe-F.P.Journe Octa Jour et Nuit Ruthenium-Platinum series, 99 pcs LE Box+Extract from the archives 2003-octa',
        fileName: null,
        path: null,
        containerName: null,
      },
    ],
    documents: [],
    model: {
      createdAt: '2022-06-10T06:00:21.8253832',
      modifiedAt: '2022-06-10T06:00:21.8253832',
      brand: {
        createdAt: '2022-06-10T06:00:21.8074632',
        modifiedAt: '2022-06-10T06:00:21.8074632',
        fileLogoImage: null,
        fileImage: null,
        id: '4d3cf259-7228-4161-0f65-08da4aa68096',
        name: 'F.P.Journe',
        title: '',
        description: '',
        stringImage: null,
        stringLogoImage: null,
      },
      fileImage: null,
      id: 'd9b95086-1f1d-4ec6-6861-08da4aa6809a',
      brandId: '7bb309d9-7969-4834-baea-08da5c131933',
      name: 'Octa',
      stringImage: null,
    },
    id: 'b3725869-e8ee-4d01-a558-08da4aa6809c',
    modelId: 'd9b95086-1f1d-4ec6-6861-08da4aa6809a',
    price: 230000,
    availability: 'InStock',
    caseDiameter: '40 mm',
    refNumber: 'octa',
    movement: '',
    braceletMaterial: 'Crocodile skin',
    braceletColor: '',
    clasp: '',
    claspMaterial: '',
    description: '',
    dealerProductCode: '1010N3124',
    caseMaterial: 'Platinum',
    yearProduction: '2003',
    condition: 'Very good\n                     (Worn with little to no signs of wear)',
    scopeDelivery: 'Original box, original papers',
    dial: 'Grey',
    dialNumerals: '',
    name: 'F.P.Journe Octa Jour et Nuit Ruthenium/Platinum series 99 pcs LE Box+Extract from the archives 2003',
    bezelMaterial: '',
    crystal: '',
    published: true,
    url: 'https://www.chrono24.com/fpjourne/fpjourne-octa-jour-et-nuit-rutheniumplatinum-series-99-pcs-le-boxextract-from-the-archives-2003--id21887842.htm',
  },
  {
    createdAt: '0001-01-01T00:00:00',
    modifiedAt: '2022-11-01T13:28:15.3590663',
    tags: [],
    images: [
      {
        url: 'https://ucarecdn.com/67c2b31a-cd14-4389-a50f-7a00226386b2/-/preview/1000x1000/-/format/webp/F.P.Journe-F.P.Journe Octa Lune Platinum 38mm Brass Movement Unique Patina Dial Box+Extract from the archives-Octa Lune',
        fileName: null,
        path: null,
        containerName: null,
      },
      {
        url: 'https://ucarecdn.com/95823931-f689-4f16-b57d-0e034a940655/-/preview/1000x1000/-/format/webp/F.P.Journe-F.P.Journe Octa Lune Platinum 38mm Brass Movement Unique Patina Dial Box+Extract from the archives-Octa Lune',
        fileName: null,
        path: null,
        containerName: null,
      },
      {
        url: 'https://ucarecdn.com/ed9c2861-6ae1-4236-998f-398f58a0f3b9/-/preview/1000x1000/-/format/webp/F.P.Journe-F.P.Journe Octa Lune Platinum 38mm Brass Movement Unique Patina Dial Box+Extract from the archives-Octa Lune',
        fileName: null,
        path: null,
        containerName: null,
      },
      {
        url: 'https://ucarecdn.com/b11b2bc6-634d-46a9-b39f-bdaf1dcb7c2b/-/preview/1000x1000/-/format/webp/F.P.Journe-F.P.Journe Octa Lune Platinum 38mm Brass Movement Unique Patina Dial Box+Extract from the archives-Octa Lune',
        fileName: null,
        path: null,
        containerName: null,
      },
      {
        url: 'https://ucarecdn.com/63bd746f-dff7-4487-8438-cd41bacb93ef/-/preview/1000x1000/-/format/webp/F.P.Journe-F.P.Journe Octa Lune Platinum 38mm Brass Movement Unique Patina Dial Box+Extract from the archives-Octa Lune',
        fileName: null,
        path: null,
        containerName: null,
      },
      {
        url: 'https://ucarecdn.com/d8dbb737-f984-42f1-be5b-ecac676c220e/-/preview/1000x1000/-/format/webp/F.P.Journe-F.P.Journe Octa Lune Platinum 38mm Brass Movement Unique Patina Dial Box+Extract from the archives-Octa Lune',
        fileName: null,
        path: null,
        containerName: null,
      },
      {
        url: 'https://ucarecdn.com/1901042b-84a0-44bb-a080-79749736a1f5/-/preview/1000x1000/-/format/webp/F.P.Journe-F.P.Journe Octa Lune Platinum 38mm Brass Movement Unique Patina Dial Box+Extract from the archives-Octa Lune',
        fileName: null,
        path: null,
        containerName: null,
      },
      {
        url: 'https://ucarecdn.com/f74cf451-2af8-4445-a96c-0d014c9014e2/-/preview/1000x1000/-/format/webp/F.P.Journe-F.P.Journe Octa Lune Platinum 38mm Brass Movement Unique Patina Dial Box+Extract from the archives-Octa Lune',
        fileName: null,
        path: null,
        containerName: null,
      },
    ],
    documents: [],
    model: {
      createdAt: '2022-06-10T06:00:21.8253832',
      modifiedAt: '2022-06-10T06:00:21.8253832',
      brand: {
        createdAt: '2022-06-10T06:00:21.8074632',
        modifiedAt: '2022-06-10T06:00:21.8074632',
        fileLogoImage: null,
        fileImage: null,
        id: '4d3cf259-7228-4161-0f65-08da4aa68096',
        name: 'F.P.Journe',
        title: '',
        description: '',
        stringImage: null,
        stringLogoImage: null,
      },
      fileImage: null,
      id: 'd9b95086-1f1d-4ec6-6861-08da4aa6809a',
      brandId: '7bb309d9-7969-4834-baea-08da5c131933',
      name: 'Octa',
      stringImage: null,
    },
    id: 'bea22d3e-7bda-496c-a54c-08da4aa6809c',
    modelId: 'd9b95086-1f1d-4ec6-6861-08da4aa6809a',
    price: 180000,
    availability: 'InStock',
    caseDiameter: '38 mm',
    refNumber: 'Octa Lune',
    movement: 'Automatic',
    braceletMaterial: 'Crocodile skin',
    braceletColor: '',
    clasp: '',
    claspMaterial: '',
    description: '',
    dealerProductCode: '1010N3050',
    caseMaterial: 'Platinum',
    yearProduction: '2004',
    condition: 'Very good\n                     (Worn with little to no signs of wear)',
    scopeDelivery: 'Original box, original papers',
    dial: '',
    dialNumerals: '',
    name: 'F.P.Journe Octa Lune Platinum 38mm Brass Movement Unique Patina Dial Box+Extract from the archives',
    bezelMaterial: '',
    crystal: '',
    published: true,
    url: 'https://www.chrono24.com/fpjourne/fpjourne-octa-lune-platinum-38mm-brass-movement-unique-patina-dial-boxextract-from-the-archives--id21067205.htm',
  },
  {
    createdAt: '0001-01-01T00:00:00',
    modifiedAt: '2022-11-01T13:28:15.3590663',
    tags: [],
    images: [
      {
        url: 'https://cdn2.chrono24.com/images/uhren/25962581-wst0m66syw6kqtxk6ksji92z-ExtraLarge.jpg',
        fileName: null,
        path: null,
        containerName: null,
      },
    ],
    documents: [],
    model: {
      createdAt: '2022-06-10T06:00:21.8253832',
      modifiedAt: '2022-06-10T06:00:21.8253832',
      brand: {
        createdAt: '2022-06-10T06:00:21.8074632',
        modifiedAt: '2022-06-10T06:00:21.8074632',
        fileLogoImage: null,
        fileImage: null,
        id: '4d3cf259-7228-4161-0f65-08da4aa68096',
        name: 'F.P.Journe',
        title: '',
        description: '',
        stringImage: null,
        stringLogoImage: null,
      },
      fileImage: null,
      id: 'd9b95086-1f1d-4ec6-6861-08da4aa6809a',
      brandId: '7bb309d9-7969-4834-baea-08da5c131933',
      name: 'Octa',
      stringImage: null,
    },
    id: 'bea22d3e-7bda-496c-a54c-08da4aa6809c',
    modelId: 'd9b95086-1f1d-4ec6-6861-08da4aa6809a',
    price: 88500,
    availability: 'InStock',
    caseDiameter: '38 mm',
    refNumber: 'Octa Lune',
    movement: 'Automatic',
    braceletMaterial: 'Crocodile skin',
    braceletColor: '',
    clasp: '',
    claspMaterial: '',
    description: '',
    dealerProductCode: '10/2022/5052/4',
    caseMaterial: 'Platinum',
    yearProduction: '2004',
    condition: 'Very good\n                     (Worn with little to no signs of wear)',
    scopeDelivery: 'Original box, original papers',
    dial: '',
    dialNumerals: '',
    name: 'F.P.Journe Souveraine',
    bezelMaterial: '',
    crystal: '',
    published: true,
    url: 'https://www.chrono24.com/fpjourne/fpjourne-octa-automatic-ptdiamond-set--id25962581.htm#gref',
  },
  {
    createdAt: '0001-01-01T00:00:00',
    modifiedAt: '2022-11-01T13:28:15.3590663',
    tags: [],
    images: [
      {
        url: 'https://cdn2.chrono24.com/images/uhren/23093012-ndbj7gwrtfdont65z102v5mu-ExtraLarge.jpg',
        fileName: null,
        path: null,
        containerName: null,
      },
    ],
    documents: [],
    model: {
      createdAt: '2022-06-10T06:00:21.8253832',
      modifiedAt: '2022-06-10T06:00:21.8253832',
      brand: {
        createdAt: '2022-06-10T06:00:21.8074632',
        modifiedAt: '2022-06-10T06:00:21.8074632',
        fileLogoImage: null,
        fileImage: null,
        id: '4d3cf259-7228-4161-0f65-08da4aa68096',
        name: 'F.P.Journe',
        title: '',
        description: '',
        stringImage: null,
        stringLogoImage: null,
      },
      fileImage: null,
      id: 'd9b95086-1f1d-4ec6-6861-08da4aa6809a',
      brandId: '7bb309d9-7969-4834-baea-08da5c131933',
      name: 'Souveraine',
      stringImage: null,
    },
    id: 'bea22d3e-7bda-496c-a54c-08da4aa6809c',
    modelId: 'd9b95086-1f1d-4ec6-6861-08da4aa6809a',
    price: 88000,
    availability: 'InStock',
    caseDiameter: '38 mm',
    refNumber: 'Octa Lune',
    movement: 'Automatic',
    braceletMaterial: 'Crocodile skin',
    braceletColor: '',
    clasp: '',
    claspMaterial: '',
    description: '',
    dealerProductCode: '1010KER',
    caseMaterial: 'Platinum',
    yearProduction: '2004',
    condition: 'Very good\n                     (Worn with little to no signs of wear)',
    scopeDelivery: 'Original box, original papers',
    dial: '',
    dialNumerals: '',
    name: 'F.P.Journe Souveraine',
    bezelMaterial: '',
    crystal: '',
    published: true,
    url: 'https://www.chrono24.com/fpjourne/fpjourne-chronometre-souverain-platinum-full-set-2019-like-new--id23093012.htm',
  },

  {
    id: '',
    name: '',
    price: 0,
    dealerProductCode: '',
    tags: [],
    images: [
      {
        url: 'https://ucarecdn.com/c9af2cf8-b66b-4cec-9b5a-07db4376fd0a/-/preview/500x500/-/format/webp/Breitling-Breitling Navitimer-A41322.jpeg',
        fileName: null,
        path: null,
        containerName: null,
      },
      {
        url: 'https://ucarecdn.com/d9239e9c-1101-4053-b244-9f6f384f1f48/-/preview/500x500/-/format/webp/Breitling-Breitling Navitimer-A41322.jpeg',
        fileName: null,
        path: null,
        containerName: null,
      },
      {
        url: 'https://ucarecdn.com/9c27c364-530c-43e8-bff4-ba5a5ac1325b/-/preview/500x500/-/format/webp/Breitling-Breitling Navitimer-A41322.jpeg',
        fileName: null,
        path: null,
        containerName: null,
      },
    ],
    model: {
      createdAt: '',
      modifiedAt: '',
      brand: {
        createdAt: '',
        modifiedAt: '',
        fileLogoImage: null,
        fileImage: null,
        id: '',
        name: '',
        title: '',
        description: '',
        stringImage: null,
        stringLogoImage: null,
      },
      fileImage: null,
      id: '',
      brandId: '',
      name: '',
      stringImage: null,
    },
    caseDiameter: '',
    published: true,
    createdAt: '',
    modifiedAt: '',
  },
];
